import { useEffect, useRef, useState } from "react";
import { UserID, EulaValue, Features, Role, Companyid, MasterId } from "../User";
import loader from "../img/sample.gif";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faFile, faFilePdf, faCloudArrowUp, faCheck, faShield, faShieldAlt, faStar, faList, faSmileBeam, faUserTie, faCheckSquare, faLightbulb, faClose, faXmark, faSearch, faDeleteLeft, faRemove, faShieldHalved, faEdit, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import Swal from 'sweetalert2';
import $ from 'jquery';
import Cookies from "js-cookie";
import grammarlypdf from "../pdf/grammarly.pdf"
import copyscapepdf from "../pdf/copyscape.pdf"
import shieldicon from "../img/shieldicon.png"
import { v4 as uuidv4, NIL as NIL_UUID } from "uuid";
import heic2any from "heic2any";
import { n2d } from "n2d";
import moment from 'moment';
import { GrammarlyEditorPlugin } from "@grammarly/editor-sdk-react";
import {
    duplicateresultcontent,
    duplicateresultparacontenttemplate,
    ChatGPTemailcontent,
    truidraggable,
  } from "../email/templateBase";
  import copy from 'copy-to-clipboard';
import { ReactSearchAutocomplete } from "react-search-autocomplete";

import ContentLoader,{List} from "react-content-loader";
// import SummaryTool from "node-summary"

export const getAccessToken = () => Cookies.get('userInfo');

// const MyLoader = () => <List />
const MyLoader = () => (    
  <ContentLoader 
  speed={1}
  width={200}
  height={100}
  viewBox="0 0 200 80"
  backgroundColor="#808080"
  foregroundColor="#ecebeb"
  style={{ width: '100%' }}
>
  <rect x="0" y="8" rx="3" ry="3" width="88" height="6" /> 
  {/* <rect x="0" y="26" rx="3" ry="3" width="52" height="6" />  */}
  <rect x="0" y="30" rx="3" ry="3" width="410" height="6" /> 
  <rect x="0" y="46" rx="3" ry="3" width="380" height="6" /> 
  <rect x="0" y="62" rx="3" ry="3" width="178" height="6" /> 
  {/* <circle cx="20" cy="20" r="20" /> */}
</ContentLoader>
  );

  export const ismobile =()=>{
    return window.screen.width <= 600;
} 

const Mls = () => {    
    var t = 0;
    const [query, setQuery] = useState("");
    const [upload_div_visibility,setupload_div_visibility] = useState(true)
    const autoCompleteRef = useRef(null);
    const [locationId, setLocationId] = useState("");
    const [generatedcontent, setgeneratedcontent] = useState("");
    const [copySacpeAvailable, setDataprop] = useState(false);
    const [grammarlyKeyData, setgrammarlyKeyData] = useState("");
    const [plagiarismmodalbody,setplagiarismmodalbody] = useState({ __html: '' });
    const [uploadedfile,setuploadedfile] = useState([]);
    const [processedimage, setprocessedimage] = useState([]);
    const [orderedprocessedimage, setorderedprocessedimage] = useState([]);
    const [dropdownvalues, setdropdownvalues] = useState([]);
    const [videocreatedformdata, setvideocreatedformdata] = useState({});
    const [uploadedimages,setuploadedimages] = useState([]);
    const [processid,setprocessid] = useState("");
    const [analyzingroomtype,setanalyzingroomtype] = useState(null);
    const [imagecaption,setimagecaption] = useState([]);
    const [roomtypes,setroomtypes] = useState([]);
    const [compliancepassed,setcompliancepassed] = useState(null);
    const [listingdescriptionstatus,setlistingdescriptionstatus] = useState(-1);
    const [fileidentity,setfileidentity] = useState("");
    const [showdeclutter,setshowdeclutter] = useState(false);
    const localimagebasepath = `${process.env.REACT_APP_API_URL}` +"/Uploads/MLSCOMPLIANCE/";
    // const localimagebasepath = "https://localhost:44372/Uploads/MLSCOMPLIANCE/";

    const [brushradius,setbrushradius] = useState(20);
    const [declutterimagewidth,setdeclutterimagewidth] = useState(0);
    const [declutterimageheight,setdeclutterimageheight] = useState(0);
    const [clearcanvas,setclearcanvas] = useState(false);
    const [showdeclutteruntouched,setshowdeclutteruntouched] = useState("");
    const [compliancefailedimagefordeclutter,setcompliancefailedimagefordeclutter] = useState(null);
    const [decluttersourceimageuntouched,setdecluttersourceimageuntouched] = useState(null);
    const [declutterimagemask,setdeclutterimagemask] = useState(null);
    const [compliancefailedimage,setcompliancefailedimage] = useState(null);
    const [declutteridentity,setdeclutteridentity] = useState(null);
    const setRadius=(value)=>{
        setbrushradius(value);
    }

    const cleanCanvas=()=>{

    }

    // const showdeclutteruntouched=()=>{

    // }

    const toggledeclutterimage=()=>{
        setshowdeclutteruntouched(!showdeclutteruntouched);
    }

    const usedeclutteredimage=()=>{
        try {
            var declutterimageidentity = declutteridentity;
            var url = document.getElementById('declutterimagesource').src;
            const sourcedeclutterURL = url;
            const decluttermimeType = "image/jpeg";
            const declutterfilename = uuidv4() + ".jpeg";
            urlToFile(sourcedeclutterURL,decluttermimeType,declutterfilename).then(file => {
                uploadsingleimagestoserver(file,processid,declutterimageidentity);
                setshowdeclutter(false);
                document.getElementById('modaldismissbutton').click();
            })
        .catch(error => {
            console.error("There was an error:", error);
            customAlertMessage('error','Error while processing image, Please try again.');
            hideoverlaydeclutter();
        });
        } catch (error) {
            console.error("There was an error:", error);
            customAlertMessage('error','Error while processing image, Please try again.');
            hideoverlaydeclutter();
        }
        
    }

    const editcompliance=(e)=>{
        var identity  = e.currentTarget.dataset.filerefid;
        var declutterelement = uploadedimages.find(x=>x.image === identity);
        if (declutterelement != undefined && declutterelement.compliancefailedimagefordeclutter != "") {
            
            // tempuploadedimagearray.compliancefailedimagefordeclutter = element.srcimgurl;
            // tempuploadedimagearray.compliancefailedimagemask = element.maskurl;
            // tempuploadedimagearray.sourceimageheight = element.srcImgH;
            // tempuploadedimagearray.sourceimagewidth = element.srcImgW;
            setcompliancefailedimagefordeclutter(declutterelement.compliancefailedimagefordeclutter);
            setdecluttersourceimageuntouched(declutterelement.compliancefailedimage);
            setdeclutterimageheight(declutterelement.sourceimageheight);
            setdeclutterimagewidth(declutterelement.sourceimagewidth);
            setdeclutterimagemask(declutterelement.compliancefailedimagemask);    
            setcompliancefailedimage(declutterelement.compliancefailedimage);
            setdeclutteridentity(identity);
            setshowdeclutteruntouched(true);
            setshowdeclutter(true);            
            document.getElementById('hrefsubscription').click();
            document.getElementById('declutterimagesource').src = declutterelement.compliancefailedimagefordeclutter;
            document.getElementById('declutterimagesource').crossOrigin = 'anonymous'
        }
        else{
            customAlertMessage('error','Please use remove or replace option.Currently we are unable to process this image.');
        }        
      }
      const hidedeclutter=(e)=>{
        setshowdeclutter(false);
      }

    const base64ToFile = (base64, mimeType, filename) => {
        // Decode the base64 string
        const byteString = atob(base64.split(',')[1]);
        // Create a Uint8Array from the byteString
        const byteArray = new Uint8Array(byteString.length);
        for (let i = 0; i < byteString.length; i++) {
            byteArray[i] = byteString.charCodeAt(i);
        }
        // Create a Blob with the desired MIME type
        const blob = new Blob([byteArray], { type: mimeType });
        // Create a File object from the Blob
        const file = new File([blob], filename, { type: mimeType });
        return file;
    }

    const savecanvasold=()=>{
        showoverlaydeclutter();
        try {
            var canvas = document.getElementsByTagName('canvas')[1];
        const ctx = canvas.getContext('2d');
        let imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    
        const tempCanvas = document.createElement('canvas');
        tempCanvas.width = canvas.width;
        tempCanvas.height = canvas.height;
        const tempCtx = tempCanvas.getContext('2d');
        // Define a threshold to consider a pixel as part of the mask
        // Here, we are considering any pixel that's not fully white as part of the mask
        const threshold = 250;
    
        // for (let i = 0; i < imageData.data.length; i += 4) {
        //     let r = imageData.data[i];
        //     let g = imageData.data[i+1];
        //     let b = imageData.data[i+2];
    
        //     // If the pixel is not white, set it to black; otherwise, set to white
        //     let value = (r < threshold || g < threshold || b < threshold) ? 0 : 255;
    
        //     imageData.data[i] = value;
        //     imageData.data[i + 1] = value;
        //     imageData.data[i + 2] = value;
        // }
    
        for (let i = 0; i < imageData.data.length; i += 4) {
            let r = imageData.data[i];
            let g = imageData.data[i+1];
            let b = imageData.data[i+2];
        
            // Define a threshold to consider a pixel as part of the mask
            const threshold = 250;
        
            // If the pixel is white (or near white), set it to black; otherwise, set to white
            let value = (r > threshold && g > threshold && b > threshold) ? 0 : 255;
        
            imageData.data[i] = value;
            imageData.data[i + 1] = value;
            imageData.data[i + 2] = value;
        }
    
        tempCtx.putImageData(imageData, 0, 0);
        // tempCtx.putImageData(newImageData, 0, 0);
        const dataURL = tempCanvas.toDataURL('image/jpeg');
        const mimeType = "image/jpeg";
        const filename = uuidv4() + ".jpeg";
    
        const maskfile = base64ToFile(dataURL, mimeType, filename);
    
        const sourcedeclutterURL = document.getElementById('declutterimagesource').src;
        const decluttermimeType = "image/jpeg";
        const declutterfilename = uuidv4() + ".jpeg";
        var sourceimage;
        if (sourcedeclutterURL.indexOf('base64') != -1) {
            sourceimage = base64ToFile(sourcedeclutterURL,decluttermimeType,declutterfilename);
            declutter(sourceimage,maskfile);
            // this.hideoverlaydeclutter();
        }
        else{
            urlToFile(sourcedeclutterURL,decluttermimeType,declutterfilename).then(file => {
                // console.log(file);  // You'll have a File object here
                declutter(file,maskfile);
                // this.hideoverlaydeclutter();
            })
            .catch(error => {
                console.error("There was an error:", error);
                customAlertMessage('error','Error while processing image.')
                hideoverlaydeclutter();
            });;
        }
        } catch (error) {
            hideoverlaydeclutter();
        }
        return;
    }
    const urlToBase64 =(url)=> {
        return fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Failed to fetch resource: ${response.statusText}`);
                }
                return response.blob();
            })
            .then(blob => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        resolve(reader.result);
                    };
                    reader.onerror = () => {
                        reject(new Error('Failed to read blob as DataURL'));
                    };
                    reader.readAsDataURL(blob);
                });
            });
    }
    
    
    const declutter =(imgsource,imgmask)=>{
        const axios = require('axios');
        const FormData = require('form-data');
        // const fs = require('fs');
        let data = new FormData();
        data.append('img', imgsource);
        data.append('mask', imgmask);
    
        let config = {
        method: 'post',
        maxBodyLength: Infinity,
        // url: 'https://aiapi.aelo.ai/declutter',    
        url: `${process.env.REACT_APP_SHERLOCKAPI_URL}` + '/api/AeloInterior/declutter',
        data : data
        };
    
        axios.request(config)
        .then((response) => {
            if (parseInt(response.data.Status) == 200) {
                cleanCanvas();
                document.getElementById('declutterimagesource').src = response.data.Data.outputurl;  
                document.getElementById('declutterimagesource').crossOrigin = 'anonymous'              
                setshowdeclutteruntouched(false);
                setTimeout(() => {
                    hideoverlaydeclutter();
                }, 2000); // image refresh time
                
            }
            else{
                customAlertMessage('error','Declutter failed, Please try again.');
                setTimeout(() => {
                    hideoverlaydeclutter();
                }, 2000); // image refresh time
            }        
            // console.log(JSON.stringify(response.data));
            
        })
        .catch((error) => {
            console.log(error);
            customAlertMessage('error','Declutter failed, Please try again.');
            hideoverlaydeclutter();
        });
      }

    const savecanvas =()=>{
        showoverlaydeclutter();
        const sourcedeclutterURL = document.getElementById('declutterimagesource').src;// compliancefailedimagefordeclutter;
        const decluttermimeType = "image/jpeg";
        const declutterfilename = uuidv4() + ".jpeg";
        urlToFile(sourcedeclutterURL,decluttermimeType,declutterfilename).then(file => {
            // console.log(file);  // You'll have a File object here
            const sourcedecluttermaskURL = declutterimagemask;
            const decluttermaskmimeType = "image/jpeg";
            const decluttermaskfilename = uuidv4() + ".jpeg";
            urlToFile(sourcedecluttermaskURL,decluttermaskmimeType,decluttermaskfilename).then(maskfile => {
                // console.log(file);  // You'll have a File object here                
                declutter(file,maskfile);
                // this.hideoverlaydeclutter();
            })
            .catch(error => {
                console.error("There was an error:", error);
                customAlertMessage('error','Error while processing image.')
                hideoverlaydeclutter();
            });
        })
        .catch(error => {
            console.error("There was an error:", error);
            customAlertMessage('error','Error while processing image.')
            hideoverlaydeclutter();
        });
    }

    const urlToFile = (url, filename, mimeType) => {
        return fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Failed to fetch resource: ${response.statusText}`);
                }
                return response.blob();
            })
            .then(blob => {
                return new File([blob], filename, { type: mimeType });
            });
    }
    
    const showoverlaydeclutter = () => {
        if (ismobile()) {
                showoverlaydecluttermobile();            
        }
        else{
            document.getElementById('overlaydeclutter').style.display = "block";
            $('body').addClass("loader");
        }
    }
    const hideoverlaydeclutter = () => {
        if (ismobile()) {
                hideoverlaydecluttermobile();
        }
        else{
            document.getElementById('overlaydeclutter').style.display = "none";
            $('body').removeClass("loader");
        }
    }

    const showoverlaydecluttermobile = () => {
        document.getElementById('overlaydecluttermobile').style.display = "block";
        $('body').addClass("loader");
        $('html').addClass("loader");
        // loadermessagesrandom();
    }
    const hideoverlaydecluttermobile = () => {
        document.getElementById('overlaydecluttermobile').style.display = "none";
        $('body').removeClass("loader");
        $('html').removeClass("loader");
    }

    // const localimagebasepath = "https://localhost:44372/Uploads/MLSCOMPLIANCE/";
    const historygoback = () => {
        window.history.back();
    }
    let autoComplete;
    let createnewcontent = false;
    const loadScript = (url, callback) => {
        let script = document.createElement("script");
        script.type = "text/javascript";
    
        if (script.readyState) {
        script.onreadystatechange = function() {
            if (script.readyState === "loaded" || script.readyState === "complete") {
            script.onreadystatechange = null;
            callback();
            }
        };
        } else {
        script.onload = () => callback();
        }
    
        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);
    };   
    function clearPropAddress(){    
        document.getElementById('txtPropAddress').value ="";
        // document.getElementById("div1Result").style.display="none";    
    }

    const resetpropertydetails=()=>{
        document.getElementById("txtArea").value = "";
        document.getElementById("ddlFloors").selectedIndex = 0;
        document.getElementById("ddlBathrooms").selectedIndex = 0;
        document.getElementById("ddlBedrooms").selectedIndex = 0;
        document.getElementById("ddlPropertyType").selectedIndex = 0;
        document.getElementById('ddlGaragetype').selectedIndex = 0;
        document.getElementById('ddlGaragespaces').selectedIndex = 0;
        
        document.querySelectorAll('.chkSchoolAmenities').forEach(element => {
            element.checked = false;    
        });
        document.querySelectorAll('.chkHospitalAmenities').forEach(element => {
            element.checked = false;    
        });
        document.querySelectorAll('.chkParkAmenities').forEach(element => {
            element.checked = false;    
        });
        document.querySelectorAll('.chkSupermarketAmenities').forEach(element => {
            element.checked = false;    
        });            
    }

    const resettoinitial =()=>{
        setQuery("");
        setLocationId("");
        setuploadedfile([]);
        setprocessedimage([]);
        setorderedprocessedimage([]);
        setuploadedimages([]);
        setprocessid("");
        setanalyzingroomtype(null);
        setimagecaption([]);
        setroomtypes([]);
        setcompliancepassed(null);
        setlistingdescriptionstatus(-1);
        setshowdeclutter(false);

        setbrushradius(20);
        setdeclutterimagewidth(0);
        setdeclutterimageheight(0);
        setclearcanvas(false);
        setshowdeclutteruntouched("");
        setcompliancefailedimagefordeclutter(null);
        setdecluttersourceimageuntouched(null);
        setdeclutterimagemask(null);
        setcompliancefailedimage(null);
        setdeclutteridentity(null);

        setTimeout(() => {
            document.getElementById('txtPropAddress').value = "";
            document.getElementById('div2').classList.add('inactive');
            document.getElementById('div3').classList.add('inactive');
            document.getElementById('div4').classList.add('inactive');
            document.getElementsByClassName('photobreak')[0].innerHTML = '';
            document.getElementById('complianceproceed').style.display = 'none';

            document.getElementById("txtArea").value = "";
            document.getElementById("ddlFloors").selectedIndex = 0;
            document.getElementById("ddlBathrooms").selectedIndex = 0;
            document.getElementById("ddlBedrooms").selectedIndex = 0;
            document.getElementById("ddlPropertyType").selectedIndex = 0;
            document.getElementById('ddlGaragetype').selectedIndex = 0;
            document.getElementById('ddlGaragespaces').selectedIndex = 0;
            
            document.getElementById('divSchoolsData').innerHTML ="";
            document.getElementById('divHospitalsData').innerHTML = "";
            document.getElementById('divParksData').innerHTML = "";
            document.getElementById('divSsupermarketsData').innerHTML = "";

            document.getElementById('showstartbtn').style.display = 'none';
            document.getElementById("divGeneratedContent").innerHTML="";
            document.getElementById('divpropertydetails').style.display = "none";
            document.getElementById('editordiv').style.display = "none";
        }, 500);
    }
    const componentDidMount=()=>{
        // load initial data
        // onTabClick(1);
        document.addEventListener('copy', function(e) {
            const text_only = document.getSelection().toString();
            const clipdata = e.clipboardData || window.clipboardData;  
            clipdata.setData('text/plain', text_only);  
            e.preventDefault();
          });
    };

    function checkcopyscape(){
        const axios = require('axios');
        let config = {
          method: 'get',
          maxBodyLength: Infinity,
          url: `${process.env.REACT_APP_API_URL}` + '/api/ArtificialIntelligence/Getcopyscapeavailable?userid=' + (Role == 3 ? MasterId : UserID)
        };
      
        axios.request(config)
        .then((response) => {
          if (response.data != null && response.data.Data !="") {
            var resd = response.data.Data;
            setDataprop(resd);
          }
        })
        .catch((error) => {
          console.log(error);
          setDataprop(false);
        });
      }

      useEffect(() => {
        componentDidMount();
        loadScript(
          `https://maps.googleapis.com/maps/api/js?key=AIzaSyDxpx25xmwMAYNW3Diz0TjL3N8CtTURTK0&libraries=places`,
          () => handleScriptLoad(setQuery, autoCompleteRef,setLocationId)
        );
        // checkcopyscape();
        var localgrammarlyKeyData = (Cookies.get('g_key') != undefined ? Cookies.get('g_key') : ''); 
        setgrammarlyKeyData(localgrammarlyKeyData);
      }, []);
    
    // useEffect(() => {
    //     if (analyzingroomtype == false) {
    //         setTimeout(() => {
    //             processcompliance(processid);
    //         }, 1000);
    //     }
    //  }, [analyzingroomtype]);

     useEffect(()=>{
        // if (compliancepassed) {
            checkcopyscape();
        // }
     },[compliancepassed])

     useEffect(()=>{
        startprocess();
        console.log('startprocess from useeffect');
     },[processid])

     useEffect(()=>{
        if (processid != "") {
            startprocess();
            console.log('startprocess single from useeffect');
        }
     },[fileidentity])

     function handleScriptLoad(updateQuery, autoCompleteRef,updateLocation) {
        autoComplete = new window.google.maps.places.Autocomplete(
          autoCompleteRef.current,
          { types: ["address"], componentRestrictions: { country: "us" } }
        );
        autoComplete.setFields(["address_components", "formatted_address","place_id","geometry"]);
        autoComplete.addListener("place_changed", () =>
          handlePlaceSelect(updateQuery,updateLocation)
        );
      }

      async function handlePlaceSelect(updateQuery,UpdateLocation) {
        const addressObject = autoComplete.getPlace();
        const query = addressObject.formatted_address;
        updateQuery(query);
        // console.log(addressObject);
        const latitude = addressObject.geometry.location.lat();
        const longitude = addressObject.geometry.location.lng();
        // console.log(latitude + "," + longitude);
        UpdateLocation(latitude + "," + longitude);
        document.getElementById("hfLocationId").value = latitude + "," + longitude;
        onAddressSelection(latitude,longitude);
        getBKIPropertyInfo(query);
      } 

      function onAddressSelection (funlat,funlng){
        //alert('inside address selection');
        var locationIdValue = document.getElementById("hfLocationId").value
        //console.log('address location id '+ locationIdValue);    
        // showoverlay();
        setTimeout(() => {
            loadAmenities(funlat,funlng);    
        }, 3000);
        
    }
    
    function getBKIPropertyInfo(addressProp){
        addressProp = encodeURI(addressProp);
        const axios = require('axios');
        let config = {
          method: 'get',
          maxBodyLength: Infinity,
          url: `${process.env.REACT_APP_API_URL}` + '/api/AIUserManager/GetBKIPropertyInfo?UserId=userid&PropertyAddress='+ addressProp
        };
      
        axios.request(config)
        .then((response) => {
          if (response.data != null && response.data.Status == "200" && response.data.Data !=null && response.data.Data !="") {
            var resd = response.data.Data;        
            // console.log("Property found");
            try {
                // bind data
            //     "Basement": null,
            // "Baths": null, -- ddlBathrooms -- DONE
            // "Bedrooms": "0", // ddlBedrooms -- DONE
            // "Fireplace": null, // txtGLR -- DONE
            // "FullBaths": "0",
            // "GarageNumCars": "2", // ddlGaragespaces -- DONE
            // "LotSize": "2", txtArea
            // "PartialBaths": "0",
            // "Pool": null, DONE -- DONE
            // "PropertyType" : "Residential",  -- ddlPropertyType or UseCodeDescription  -- DONE
            // "Stories": "1 Story", // ddlFloors --
            // "YearBuilt": "1997" // 
                
                if (resd.Baths !=null && resd.Baths != undefined && resd.Baths != "") {
                    var tBaths = parseInt(resd.Baths);
                    if (tBaths > 0 && tBaths < 11) {
                         document.getElementById("ddlBathrooms").value = tBaths;
                    }
                }
                if (resd.Bedrooms !=null && resd.Bedrooms != undefined && resd.Bedrooms != "") {
                    var tbeds = parseInt(resd.Bedrooms);
                    if (tbeds > 0 && tbeds < 11) {
                         document.getElementById("ddlBedrooms").value = tbeds;
                    }
                }
                if (resd.GarageNumCars !=null && resd.GarageNumCars != undefined && resd.GarageNumCars != "") {
                    var tGarageNumCars = parseInt(resd.GarageNumCars);
                    if (tGarageNumCars > 0 && tGarageNumCars < 11) {
                         document.getElementById("ddlGaragespaces").value = tGarageNumCars;
                    }
                }
                if (resd.PropertyType !=null && resd.PropertyType != undefined && resd.PropertyType != "") {
                    //// "PropertyType" : "Residential",  -- ddlPropertyType or UseCodeDescription
                    var mainPropTypeValue = "singlefamily";
                    var propSubType="";
                    if (resd.UseCodeDescription !=null && resd.UseCodeDescription != undefined && resd.UseCodeDescription != "") {
                        propSubType = resd.UseCodeDescription;
                        if (propSubType.includes("single") || propSubType.includes("Single")) {
                            mainPropTypeValue = "singlefamily";
                        } 
                        else if (propSubType.includes("multi") || propSubType.includes("Multi")) {
                            mainPropTypeValue = "multifamily";
                        }
                        else if (propSubType.includes("condo") || propSubType.includes("Condo")) {
                            mainPropTypeValue = "condo";
                        }
                        else if (propSubType.includes("villa") || propSubType.includes("Villa")) {
                            mainPropTypeValue = "villa";
                        }
                        else if (propSubType.includes("town") || propSubType.includes("Town")) {
                            mainPropTypeValue = "townhouse";
                        }
                        else if (propSubType.includes("apartment") || propSubType.includes("Apartment")) {
                            mainPropTypeValue = "apartment";
                        }
                        else if (propSubType.includes("resident") || propSubType.includes("Resident") || propSubType.includes("Resi")) {
                            mainPropTypeValue = "residential";
                        }
                        else if (propSubType.includes("land") || propSubType.includes("Land")) {
                            mainPropTypeValue = "land";
                        }
                        else if (propSubType.includes("commercial") || propSubType.includes("Commercial") || propSubType.includes("Comm")) {
                            mainPropTypeValue = "commercial";
                        }
                        //commercial
                    } else {
                        propSubType = resd.PropertyType;
                        if (propSubType.includes("resident") || propSubType.includes("Resident") || propSubType.includes("Resi")) {
                            mainPropTypeValue = "residential";
                        }
                        else if (propSubType.includes("land") || propSubType.includes("Land")) {
                            mainPropTypeValue = "land";
                        }
                        else if (propSubType.includes("commercial") || propSubType.includes("Comm") || propSubType.includes("Commercial")) {
                            mainPropTypeValue = "commercial";
                        }
                    }
                    document.getElementById("ddlPropertyType").value = mainPropTypeValue;
                } // end of property type

                // if (resd.Fireplace !=null && resd.Fireplace != undefined && resd.Fireplace != "") {
                //     document.getElementById("txtMostSalable").value = "FirePlace " + resd.Fireplace;
                // }
                // if (resd.Pool !=null && resd.Pool != undefined && resd.Pool != "") {
                //     var txtGLR = document.getElementById("txtMostSalable");
                //     if (txtGLR.value !="") {
                //         txtGLR.value = ", Pool " + resd.Pool;
                //     } else {
                //         txtGLR.value = "Pool " + resd.Pool;
                //     }                
                // }
                if (resd.LotSize !=null && resd.LotSize != undefined && resd.LotSize != "") {
                    var tLotSize = parseFloat(resd.LotSize);
                    if (tLotSize > 0) {
                        document.getElementById("txtArea").value = tLotSize.toString();
                    }
                }
                if (resd.Stories !=null && resd.Stories != undefined && resd.Stories != "") {
                    var tStories = resd.Stories;
                    var stories =0;
                    if (tStories.includes("1")) {
                        stories=1;
                    }
                    else if (tStories.includes("2")) {
                        stories=2;
                    }
                    else if (tStories.includes("3")) {
                        stories=3;
                    }
                    else if (tStories.includes("4")) {
                        stories=4;
                    }
                    else if (tStories.includes("5")) {
                        stories=5;
                    }
    
                    if (tStories > 0 && tStories < 6) {
                        document.getElementById("ddlFloors").value = stories;
                    }
                }
            } catch (error) {
                console.log("error in Property binding");
            }
          }
        })
        .catch((error) => {
          console.log("Property not found");
        });
    }

     function copyToClipboard() {
        copy(document.getElementById('divGeneratedContent').innerText,{format:"text/plain"});    
        customAlertMessage('success','Copied!');  
    };
    
    function copyToClipboardEdit(){
        if(document.getElementById('hrefEditContent').innerText=="Update"){
            document.getElementById('divGeneratedContent').contentEditable ="false";
            document.getElementById('hrefEditContent').innerText="Edit";
        }
        else{
            document.getElementById('divGeneratedContent').contentEditable ="true";
            document.getElementById('hrefEditContent').innerText="Update";
        }    
    }
    const checkCountersLimit=()=>{
        var userI = getAccessToken();
        var decodedUser1 = decodeURIComponent(userI);
        var parsedRes1 = JSON.parse(decodedUser1); 
        var PlanType = parsedRes1.PlanType;  
        if (PlanType < 1) { // free trial
            const axios = require('axios');
            let config = {
              method: 'get',
              maxBodyLength: Infinity,
              url: `${process.env.REACT_APP_API_URL}` + '/api/AIUserManager/GetUserCounters?UserId='+(Role == 3 ? MasterId : UserID)+'&CounterType=UsedPropertyDescription',
              headers: { }
            };
          
            axios.request(config)
            .then((response) => {
            //   console.log(JSON.stringify(response.data));
              if (response.data != undefined) {
                if ((response.data.Data != "" || response.data.Data == 0) && response.data.Status == "200") {
                    var availblecounter = response.data.Data;
                    if (availblecounter <= 0) {
                            document.getElementById('psubtext').innerText = 'You trial resources have been exhausted. Please upgrade to a paid subscription.';
                            document.getElementById('hrefsubscription').click();
                            return;
                    }
                    else{
                        generateaicontentCounters();
                        // movetoordering();
                    }
                }
              }
            })
            .catch((error) => {
              console.log(error);
            });
            // end of free trial
        }else {
            generateaicontentCounters();
            //movetoordering();
        }
    }
    const generateaicontent=()=>{
        createnewcontent = true;
        showoverlayprop();
        setTimeout(() => {
            checkCountersLimit();    
        }, 3000);        
    }
    function customAlertMessage(icon, message) {
        const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: false,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
        })
    
        Toast.fire({
            icon: icon,//'success',
            title: message// 'Signed in successfully'
        })
    }
    
    const triggerfileupload = (e)=>{
        var dropzonenewbtn = e.currentTarget.parentElement.querySelectorAll('.dropzonenew')[0];
        dropzonenewbtn.click();
    }
    
    const dropzonechangesingle = (e)=> {
        try {
            var tempfilesarr = e.target.files;// $(".dropzone")[0].files;
            var filreferenceidentity = e.currentTarget.dataset.filreferenceidentity;
        if (tempfilesarr.length <= 0) {
            return;
        }
        // showoverlaytwo();
        var tempfileaftervalidation = [];
        var uploadedfilearray = [];// uploadedfile;
        var containsiphonefiles = false;
        var invalidfilecount = 0;
        for (let i = 0; i < tempfilesarr.length; i++) {
            const element = tempfilesarr[i];
            var validfile = (element.type === 'image/jpg' || element.type === 'image/jpeg' || element.type === "image/png")
            if (!validfile && element.name.split('.').pop() != "heif" && element.name.split('.').pop() != "heic") {
                customAlertMessage('error', 'File type not supported files removed.');
                invalidfilecount += 1;
                continue;
            }
            // if (element.size < 10485760) {
            if (true) {
                uploadsingleimagestoserver(element,processid,filreferenceidentity);
                return;
                var uploadedfile_json = {};
                var tempfileaftervalidation_json = {};
                if (element.name.split('.').pop() != 'heif' && element.name.split('.').pop() != 'heic') {
                    // var alreadyuploadedfile = uploadedfile.filter(function (entry) { return entry.binaryfile == element; });
                    // if (alreadyuploadedfile.length > 0) {
                    //     continue;
                    // }
                    var uniqueid = uuidv4();
                    uploadedfile_json.identity = uniqueid;
                    uploadedfile_json.binaryfile = element;
                    uploadedfilearray.push(uploadedfile_json);

                    tempfileaftervalidation_json.identity = uniqueid;
                    tempfileaftervalidation_json.binaryfile = element;
                    tempfileaftervalidation.push(tempfileaftervalidation_json);
                    console.log('file added: '+ element.name);
                }
                else {
                    containsiphonefiles = true
                }
            }
            else {
                customAlertMessage('error', 'Maximum file size exceeded images removed.');
                invalidfilecount += 1;
            }
        }
        if (containsiphonefiles) {
            for (let i = 0; i < tempfilesarr.length; i++) {
                const element = tempfilesarr[i];
                if (element.name.split('.').pop() == "heif" || element.name.split('.').pop() == "heic") {
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        // showoverlaytwo();
                        fetch(e.target.result)
                            .then((res) => res.blob())
                            .then((blob) => heic2any({ blob, toType: "image/jpeg", quality: 0.1 }))
                            .then((conversionResult) => {
                                // conversionResult is a BLOB
                                // of the PNG formatted image
                                var url = URL.createObjectURL(conversionResult);
                                var file = new File([conversionResult], uuidv4() + ".jpg");
                                uploadsingleimagestoserver(file,processid,filreferenceidentity);
                                return;
                                // var alreadyuploadedfile = uploadedfile.filter(function (entry) { return entry.binaryfile == element; });
                                // if (alreadyuploadedfile.length <= 0) {
                                //     continue;
                                // }
                                var uploadedfile_json = {};
                                var tempfileaftervalidation_json = {};
                                var uniqueid = uuidv4();
                                uploadedfile_json.identity = uniqueid;
                                uploadedfile_json.binaryfile = file;
                                uploadedfilearray.push(uploadedfile_json);

                                tempfileaftervalidation_json.identity = uniqueid;
                                tempfileaftervalidation_json.binaryfile = file;
                                tempfileaftervalidation.push(tempfileaftervalidation_json);
                                // console.log('file added iphone: '+ file.name);
                                // console.log('files added : '+ tempfileaftervalidation.length);
                                if (tempfilesarr.length <= (invalidfilecount + uploadedfilearray.length)) {
                                    // console.log('fired to load inside iphone')
                                    setTimeout(() => {
                                        readFile(tempfileaftervalidation);
                                        setuploadedfile(uploadedfile => [...uploadedfile, ...uploadedfilearray]);    
                                    }, 2000);
                                }
                            })
                            .catch((e) => {
                                // see error handling section
                                //customAlertMessage('error','Error occured while processing an image, please try again.'); 
                                // hideoverlaytwo();
                                invalidfilecount += 1;
                                if (tempfilesarr.length <= (invalidfilecount + uploadedfilearray.length)) {
                                    readFile(tempfileaftervalidation);
                                    setuploadedfile(uploadedfile => [...uploadedfile, ...uploadedfilearray]);  
                                }
                            });
                    }
                    reader.readAsDataURL(element);
                }
            }
        }
        else {
            //should not come here
            uploadsingleimagestoserver(tempfilesarr[0],processid,filreferenceidentity);
            return;
            readFile(tempfileaftervalidation);
            setuploadedfile(uploadedfile => [...uploadedfile, ...uploadedfilearray]);
            // console.log('fired to load outside iphone')
        }
        } catch (error) {
            console.log(error);
            hideoverlaytwo();
        }
        
    };

    const dropzonechange = (e)=> {
        try {
            var tempfilesarr = e.target.files;// $(".dropzone")[0].files;
        if (tempfilesarr.length <= 0) {
            return;
        }
        // showoverlaytwo();
        var tempfileaftervalidation = [];
        var uploadedfilearray = [];// uploadedfile;
        var containsiphonefiles = false;
        var invalidfilecount = 0;
        for (let i = 0; i < tempfilesarr.length; i++) {
            const element = tempfilesarr[i];
            var validfile = (element.type === 'image/jpg' || element.type === 'image/jpeg' || element.type === "image/png")
            if (!validfile && element.name.split('.').pop() != "heif" && element.name.split('.').pop() != "heic") {
                customAlertMessage('error', 'File type not supported files removed.');
                invalidfilecount += 1;
                continue;
            }
            // if (element.size < 10485760) {
            if (true) {
                var uploadedfile_json = {};
                var tempfileaftervalidation_json = {};
                if (element.name.split('.').pop() != 'heif' && element.name.split('.').pop() != 'heic') {
                    // var alreadyuploadedfile = uploadedfile.filter(function (entry) { return entry.binaryfile == element; });
                    // if (alreadyuploadedfile.length > 0) {
                    //     continue;
                    // }
                    var uniqueid = uuidv4();
                    uploadedfile_json.identity = uniqueid;
                    uploadedfile_json.binaryfile = element;
                    uploadedfilearray.push(uploadedfile_json);

                    tempfileaftervalidation_json.identity = uniqueid;
                    tempfileaftervalidation_json.binaryfile = element;
                    tempfileaftervalidation.push(tempfileaftervalidation_json);
                    // console.log('file added: '+ element.name);
                }
                else {
                    containsiphonefiles = true
                }
            }
            else {
                customAlertMessage('error', 'Maximum file size exceeded images removed.');
                invalidfilecount += 1;
            }
        }
        if (containsiphonefiles) {
            for (let i = 0; i < tempfilesarr.length; i++) {
                const element = tempfilesarr[i];
                if (element.name.split('.').pop() == "heif" || element.name.split('.').pop() == "heic") {
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        // showoverlaytwo();
                        fetch(e.target.result)
                            .then((res) => res.blob())
                            .then((blob) => heic2any({ blob, toType: "image/jpeg", quality: 0.1 }))
                            .then((conversionResult) => {
                                // conversionResult is a BLOB
                                // of the PNG formatted image
                                var url = URL.createObjectURL(conversionResult);
                                var file = new File([conversionResult], uuidv4() + ".jpg");
                                // var alreadyuploadedfile = uploadedfile.filter(function (entry) { return entry.binaryfile == element; });
                                // if (alreadyuploadedfile.length <= 0) {
                                //     continue;
                                // }
                                var uploadedfile_json = {};
                                var tempfileaftervalidation_json = {};
                                var uniqueid = uuidv4();
                                uploadedfile_json.identity = uniqueid;
                                uploadedfile_json.binaryfile = file;
                                uploadedfilearray.push(uploadedfile_json);

                                tempfileaftervalidation_json.identity = uniqueid;
                                tempfileaftervalidation_json.binaryfile = file;
                                tempfileaftervalidation.push(tempfileaftervalidation_json);
                                // console.log('file added iphone: '+ file.name);
                                // console.log('files added : '+ tempfileaftervalidation.length);
                                if (tempfilesarr.length <= (invalidfilecount + uploadedfilearray.length)) {
                                    // console.log('fired to load inside iphone')
                                    setTimeout(() => {
                                        readFile(tempfileaftervalidation);
                                        setuploadedfile(uploadedfile => [...uploadedfile, ...uploadedfilearray]);    
                                    }, 2000);
                                }
                            })
                            .catch((e) => {
                                // see error handling section
                                //customAlertMessage('error','Error occured while processing an image, please try again.'); 
                                // hideoverlaytwo();
                                invalidfilecount += 1;
                                if (tempfilesarr.length <= (invalidfilecount + uploadedfilearray.length)) {
                                    readFile(tempfileaftervalidation);
                                    setuploadedfile(uploadedfile => [...uploadedfile, ...uploadedfilearray]);  
                                }
                            });
                    }
                    reader.readAsDataURL(element);
                }
            }
        }
        else {
            readFile(tempfileaftervalidation);
            setuploadedfile(uploadedfile => [...uploadedfile, ...uploadedfilearray]);
            // console.log('fired to load outside iphone')
        }
        } catch (error) {
            console.log(error);
            hideoverlaytwo();
        }
        
    };
    const dropzonedragenter = (e) => {
        e.preventDefault();
            e.stopPropagation();
            $('.dropzone-wrapper').addClass('dragover');
    }
    const dropzonedragover = (e) => {
        e.preventDefault();
        e.stopPropagation();
        $('.dropzone-wrapper').addClass('dragover');
    };
    const dropzonedragleave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        $('.dropzone-wrapper').removeClass('dragover');
    };
    const dropzonefiledrop = (event) => {
        event.preventDefault();
        var tempfilesarr = event.dataTransfer.files;
        var tempfileaftervalidation = [];
        var uploadedfilearray = [];// uploadedfile;
        var containsiphonefiles = false;
        var invalidfilecount = 0;
        for (let i = 0; i < tempfilesarr.length; i++) {
            const element = tempfilesarr[i];
            var validfile = (element.type === 'image/jpg' || element.type === 'image/jpeg' || element.type === "image/png")
            if (!validfile && element.name.split('.').pop() != "heif" && element.name.split('.').pop() != "heic") {
                customAlertMessage('error', 'File type not supported files removed.');
                invalidfilecount += 1;
                continue;
            }
            // if (element.size < 10485760) {
            if (true) {
                var uploadedfile_json = {};
                var tempfileaftervalidation_json = {};
                if (element.name.split('.').pop() != 'heif' && element.name.split('.').pop() != 'heic') {
                    var uniqueid = uuidv4();
                    uploadedfile_json.identity = uniqueid;
                    uploadedfile_json.binaryfile = element;
                    uploadedfilearray.push(uploadedfile_json);

                    tempfileaftervalidation_json.identity = uniqueid;
                    tempfileaftervalidation_json.binaryfile = element;
                    tempfileaftervalidation.push(tempfileaftervalidation_json);
                }
                else {
                    containsiphonefiles = true
                }
            }
            else {
                customAlertMessage('error', 'Maximum file size exceeded images removed.');
                invalidfilecount += 1;
            }
        }
        if (containsiphonefiles) {
            for (let i = 0; i < tempfilesarr.length; i++) {
                const element = tempfilesarr[i];
                if (element.name.split('.').pop() == "heif" || element.name.split('.').pop() == "heic") {
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        // showoverlaytwo();
                        fetch(e.target.result)
                            .then((res) => res.blob())
                            .then((blob) => heic2any({ blob, toType: "image/jpeg", quality: 0.1 }))
                            .then((conversionResult) => {
                                // conversionResult is a BLOB
                                // of the PNG formatted image
                                var url = URL.createObjectURL(conversionResult);
                                var file = new File([conversionResult], uuidv4() + ".jpg");
                                var uploadedfile_json = {};
                                var tempfileaftervalidation_json = {};
                                var uniqueid = uuidv4();
                                uploadedfile_json.identity = uniqueid;
                                uploadedfile_json.binaryfile = file;
                                uploadedfilearray.push(uploadedfile_json);

                                tempfileaftervalidation_json.identity = uniqueid;
                                tempfileaftervalidation_json.binaryfile = file;
                                tempfileaftervalidation.push(tempfileaftervalidation_json);
                                if (tempfilesarr.length <= (invalidfilecount + uploadedfilearray.length)) {
                                    readFileondrop(tempfileaftervalidation);
                                    setuploadedfile(uploadedfile => [...uploadedfile, ...uploadedfilearray]);
                                }
                            })
                            .catch((e) => {
                                // see error handling section
                                //customAlertMessage('error','Error occured while processing an image, please try again.'); 
                                // hideoverlaytwo();
                                invalidfilecount += 1;
                                if (tempfilesarr.length <= (invalidfilecount + uploadedfilearray.length)) {
                                    readFile(tempfileaftervalidation);
                                    setuploadedfile(uploadedfile => [...uploadedfile, ...uploadedfilearray]);
                                }
                            });

                    }
                    reader.readAsDataURL(element);
                }
            }
        }
        else {
            readFileondrop(tempfileaftervalidation);
            setuploadedfile(uploadedfile => [...uploadedfile, ...uploadedfilearray]);
        }
        // $(".dropzone")[0].value = "";
    };

    const readFileondrop = (inputfiles) => {
        var singletimearray = []; // processedimage;
        var propertyorderedlist = [];// [...orderedprocessedimage];
        let tempprocessedfiles = 0;
        for (let i = 0; i < inputfiles.length; i++) {
            const element = inputfiles[i].binaryfile;
            var reader = new FileReader();
            reader.onload = function (e) {
                tempprocessedfiles += 1;
                var uniqimg = {};
                var timingidentity = moment().valueOf();
                uniqimg.refid = inputfiles[i].identity;
                uniqimg.id = timingidentity;
                uniqimg.image = e.target.result;
                singletimearray.push(uniqimg);
                if (orderedprocessedimage.length > 0) {
                    var selem = {};
                    selem.orderid = orderedprocessedimage.length + (i+1);
                    selem.id = timingidentity;
                    selem.refid = inputfiles[i].identity;
                    selem.image = e.target.result;
                    selem.binaryfile = element;
                    propertyorderedlist.push(selem);
                }
                if (tempprocessedfiles == inputfiles.length) {
                     var processedimagenew = singletimearray.sort(function (a, b) { return a.id - b.id; });                  
                    setprocessedimage(processedimage => [...processedimage , ...processedimagenew]);
                    setorderedprocessedimage(orderedprocessedimag => [...orderedprocessedimag , ...propertyorderedlist]);                    
                    // hideoverlaytwo();
                    // showoverlaytwo();
                    // setTimeout(() => {
                    //     loaddropdownfromstate();
                    // }, 2000);
                }

            };
            reader.readAsDataURL(element);
        }
    }
    const showoverlaytwo = () => {
        document.getElementById("overlaytwomls").style.display = "block";
        $("body").addClass("loader");
    };
    const hideoverlaytwo = () => {
        document.getElementById("overlaytwomls").style.display = "none";
        $("body").removeClass("loader");
    };
    const showoverlay = () => {
        return;
        document.getElementById("overlay").style.display = "block";
        $("body").addClass("loader");
    };
    const hideoverlay = () => {
        return;
        document.getElementById("overlay").style.display = "none";
        $("body").removeClass("loader");
    };

    const showoverlay_s_i = (identity) => {
        document.getElementById("overlay").style.display = "block";
        $("body").addClass("loader");
    };
    const hideoverlay_s_i = (identity) => {
        document.getElementById("overlay").style.display = "none";
        $("body").removeClass("loader");
    };
    // const loaddropdownfromstate = () => {
    //     if (dropdownvalues.length > 0) {
    //         var selectddl = document.getElementsByClassName('imageoption');
    //         for (let i = 0; i < selectddl.length; i++) {
    //             const element = selectddl[i];
    //             var refid = element.dataset.filerefid;
    //             var selectedoption = dropdownvalues.filter(function (entry) { return entry.refid == refid; });
    //             if (selectedoption.length > 0) {
    //                 element.value = selectedoption[0].text;
    //             }
    //         }
    //         hideoverlaytwo();
    //     }
    //     else {
    //         hideoverlaytwo();
    //     }
    // }
    const readFile = (inputfiles) => {
        // var input = $('.dropzone')[0];
        // var inputfiles = input.files;
        var singletimearray = [];// [...processedimage];
        var propertyorderedlist = [];// [...orderedprocessedimage];
        // console.log('inputfiles.length',inputfiles.length);
        let tempprocessedfiles = 0;
        for (let i = 0; i < inputfiles.length; i++) {
            const element = inputfiles[i].binaryfile;
            // console.log('reading inputfiles : ',element.name);
            var reader = new FileReader();
            reader.onload = function (e) {
                tempprocessedfiles += 1;
                var uniqimg = {};
                var timingidentity = moment().valueOf();
                uniqimg.refid = inputfiles[i].identity;
                uniqimg.id =timingidentity;
                uniqimg.image = e.target.result;
                singletimearray.push(uniqimg);
                if (orderedprocessedimage.length > 0) {
                    var selem = {};
                    selem.orderid = orderedprocessedimage.length + (i+1);
                    selem.id = timingidentity;
                    selem.refid = inputfiles[i].identity;
                    selem.image = e.target.result;
                    selem.binaryfile = element;
                    propertyorderedlist.push(selem);
                }
                if (tempprocessedfiles == inputfiles.length) {
                    var processedimagenew = singletimearray.sort(function (a, b) { return a.id - b.id; });
                    setprocessedimage(processedimage => [...processedimage , ...processedimagenew]);
                    setorderedprocessedimage(orderedprocessedimag => [...orderedprocessedimag , ...propertyorderedlist]);                    
                    // hideoverlaytwo();
                    // showoverlaytwo();
                    // setTimeout(() => {
                    //     loaddropdownfromstate();
                    // }, 2000);
                }
            };
            reader.readAsDataURL(element);
        }
    }
    const showstep1=(e)=>{
        var filteredarray = [...document.querySelectorAll('.mlsright li')].filter(el => (el.dataset.processed == "0" || el.dataset.processed == "-1"));
        if (filteredarray.length > 0) {
            customAlertMessage("error", "Please wait while we are processing the images.");
            return;
        }
        document.getElementById('upload_div').style.display ="flex";
        document.getElementById('main_div').style.display = "none";
    }
    const showstep2=(e)=>{       
        if (e.currentTarget.classList.contains('inactive') == false) {
            var filteredarray = [...document.querySelectorAll('.mlsright li')].filter(el => (el.dataset.processed == "0" || el.dataset.processed == "-1"));
            if (filteredarray.length > 0) {
                customAlertMessage("error", "Please wait while we are processing the images.");
                return;
            }
            document.getElementById('upload_div').style.display ="none";
            document.getElementById('main_div').style.display = "flex";
            document.getElementById('imagesdiv').style.display = 'block';
            document.getElementById('upload_div').style.display ="none";
            document.getElementById('editordiv').style.display = 'none';
            document.getElementById('divpropertydetails').style.display = 'none';
            document.getElementById('showstartbtn').style.display = 'flex';
        }
        
        
    }
    const showstep3=(e)=>{
        if (e.currentTarget.classList.contains('inactive') == false){
            document.getElementById('imagesdiv').style.display = 'none';
            document.getElementById('upload_div').style.display ="none";
            document.getElementById('editordiv').style.display = 'none';
            document.getElementById('divpropertydetails').style.display = 'block';
            document.getElementById('main_div').style.display = "flex";
        }
    }
    const showstep4=(e)=>{       
        if (e.currentTarget.classList.contains('inactive') == false){
            var filteredarray = [...document.querySelectorAll('.mlsright li')].filter(el => (el.dataset.processed == "0" || el.dataset.processed == "-1"));
            if (filteredarray.length > 0) {
                customAlertMessage("error", "Please wait while we are processing the images.");
                return;
            }
            document.getElementById('imagesdiv').style.display = 'none';
            document.getElementById('upload_div').style.display ="none";
            document.getElementById('divpropertydetails').style.display = 'none';
            document.getElementById('editordiv').style.display = 'block';
            document.getElementById('main_div').style.display = "flex";
        }
    }

    const uploadimages=()=>{        
        // setupload_div_visibility(false);
        var txtPropAddress = document.getElementById('txtPropAddress').value;
        if (txtPropAddress.trim() === "") {
            customAlertMessage('error', 'Please enter property address.');
            return;
        }
        if (uploadedfile.length > 0) {
            if (uploadedimages.length <= 0) {
                uploadimagestoserver();
            }
            else{
                uploadimagestoserverwithprocessid();
            }
            document.getElementById('upload_div').style.display ="none";
            document.getElementById('main_div').style.display = "flex";
            document.getElementById('div2').classList.remove('inactive');
            document.getElementById('showstartbtn').style.display = 'flex';
            document.getElementById('imagesdiv').style.display = "block";
            document.getElementById('divpropertydetails').style.display = "none";
            document.getElementById('editordiv').style.display = 'none';
        }
        else{
            customAlertMessage('error','Please select files and proceed.');
        }
        
    }
    const uploadimagestoserver=()=>{
        const axios = require('axios');
        const FormData = require('form-data');
        // const fs = require('fs');
        showoverlaytwo();
        let data = new FormData();
        data.append('uid', '3a2ab8ee-5264-4a8a-895b-bbcbb96882e0');
        data.append('companyid', '15');
        if (uploadedfile.length > 0) {
            for (let i = 0; i < uploadedfile.length; i++) {
                const element = uploadedfile[i].binaryfile;
                data.append(uploadedfile[i].identity, element);
            }
        }
        else{
            customAlertMessage('error','Please select files and proceed');
            document.getElementById('upload_div').style.display ="block";
            document.getElementById('main_div').style.display = "none";
            return;
        }
        let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}` +'/api/ArtificialIntelligence/uploadmlscomplianceimages',
        // url: 'https://localhost:44372/api/ArtificialIntelligence/uploadmlscomplianceimages',
        data : data
        };

        axios.request(config)
        .then((response) => {
            // console.log(JSON.stringify(response.data));
            var Responsedata = response.data.Data;
            if (Responsedata != "" && Responsedata != null) {
                var tempuploadedimagearray = [];
                var tempuploadedimages = Responsedata.imagelist;
                var tempduplicateimages = Responsedata.duplicates;
                tempuploadedimages.forEach(element => {
                    var imagejson = {};
                    imagejson.image = element;
                    // imagejson.processed = "-1";
                    // imagejson.compliant = "-1";
                    imagejson.compliancefailedimage = "";
                    // imagejson.spacetype = "";
                    imagejson.description = "";
                    imagejson.compliancefailedimagefordeclutter = "";
                    imagejson.compliancefailedimagemask = "";
                    imagejson.sourceimageheight = "";
                    imagejson.sourceimagewidth = "";
                    imagejson.nooftries = 0;
                    if (tempduplicateimages.indexOf(element) >= 0) {
                        // imagejson.editpermission = 2;
                        imagejson.spacetype = "Duplicate image.";
                        imagejson.editpermission = 1;
                        imagejson.description = "";
                        imagejson.processed = "1";
                        imagejson.compliant = "0";
                    }
                    else{
                        imagejson.editpermission = 0;
                        imagejson.spacetype = "";
                        imagejson.processed = "-1";
                        imagejson.compliant = "-1";
                    }
                    imagejson.condition = "NA";
                    tempuploadedimagearray.push(imagejson);
                });
                setuploadedimages(upimage => [...upimage , ...tempuploadedimagearray])
                setprocessid(Responsedata.processid);
                hideoverlaytwo();
            }
            else{
                customAlertMessage('error','Something went wrong, Please try again.');
                document.getElementById('upload_div').style.display ="block";
                document.getElementById('main_div').style.display = "none";
                hideoverlaytwo();
            }
            
        })
        .catch((error) => {
            console.log(error);
            customAlertMessage('error','Something went wrong, Please try again.');
            document.getElementById('upload_div').style.display ="block";
            document.getElementById('main_div').style.display = "none";
            hideoverlaytwo();
        });

    }

    const uploadimagestoserverwithprocessid=()=>{
        const axios = require('axios');
        const FormData = require('form-data');
        // const fs = require('fs');
        showoverlaytwo();
        let data = new FormData();
        data.append('uid', '3a2ab8ee-5264-4a8a-895b-bbcbb96882e0');
        data.append('companyid', '15');
        data.append('processid', processid);
        if (uploadedfile.length > 0) {
            for (let i = 0; i < uploadedfile.length; i++) {
                var filteredprocessimage = uploadedimages.filter(function (entry) { return entry.image === (uploadedfile[i].identity+".jpeg"); });
                if (filteredprocessimage.length <= 0) {
                    const element = uploadedfile[i].binaryfile;
                    data.append(uploadedfile[i].identity, element);    
                }                
            }
        }
        else{
            customAlertMessage('error','Please select files and proceed');
            document.getElementById('upload_div').style.display ="block";
            document.getElementById('main_div').style.display = "none";
            return;
        }
        let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}` +'/api/ArtificialIntelligence/addmlscomplianceimages',
        //  url: 'https://localhost:44372/api/ArtificialIntelligence/addmlscomplianceimages',
        data : data
        };

        axios.request(config)
        .then((response) => {
            // console.log(JSON.stringify(response.data));
            var Responsedata = response.data.Data;
            if (Responsedata != "" && Responsedata != null && Object.keys(Responsedata).length > 0) {
                var tempuploadedimagearray = [];
                var tempuploadedimages = Responsedata.imagelist;
                var tempduplicateimages = Responsedata.duplicates;
                tempuploadedimages.forEach(element => {
                    var imagejson = {};
                    imagejson.image = element;
                    // imagejson.processed = "-1";
                    // imagejson.compliant = "-1";
                    imagejson.compliancefailedimage = "";
                    // imagejson.spacetype = "";                 
                    imagejson.description = "";   
                    imagejson.compliancefailedimagefordeclutter = "";
                    imagejson.compliancefailedimagemask = "";
                    imagejson.sourceimageheight = "";
                    imagejson.sourceimagewidth = "";
                    imagejson.nooftries = 0;
                    if (tempduplicateimages.indexOf(element) >= 0) {
                        // imagejson.editpermission = 2;
                        imagejson.spacetype = "Duplicate image.";
                        imagejson.editpermission = 1;
                        imagejson.description = "";
                        imagejson.processed = "1";
                        imagejson.compliant = "0";
                    }
                    else{
                        imagejson.editpermission = 0;
                        imagejson.spacetype = "";
                        imagejson.processed = "-1";
                        imagejson.compliant = "-1";
                    }
                    tempuploadedimagearray.push(imagejson);
                });
                setuploadedimages(upimage => [ ...uploadedimages, ...tempuploadedimagearray])
                setfileidentity(uuidv4());
                // setprocessid(Responsedata.processid);
                // setTimeout(() => {
                //     startprocess_single();
                // }, 3000);
                hideoverlaytwo();
            }
            hideoverlaytwo();
            // else{
            //     customAlertMessage('error','Something went wrong, Please try again.');
            //     document.getElementById('upload_div').style.display ="block";
            //     document.getElementById('main_div').style.display = "none";
            //     hideoverlaytwo();
            // }
            
        })
        .catch((error) => {
            console.log(error);
            customAlertMessage('error','Something went wrong, Please try again.');
            document.getElementById('upload_div').style.display ="block";
            document.getElementById('main_div').style.display = "none";
            hideoverlaytwo();
        });

    }

    const replacefile=(referenceid,file,newfilename)=>{
           //Remove from first step
           getBase64(file).then(data => {
            // console.log(data);
            var filteredprocessimage = processedimage;
            filteredprocessimage.forEach(element => {
                if (element.refid == (referenceid.replace(".jpeg",""))) {
                    element.image = data;
                    element.refid = newfilename.replace(".jpeg","");
                }
            });
            // var filteredprocessimage = processedimage.filter(function (entry) { return entry.refid == (referenceid.replace(".jpeg","")); });
            // filteredprocessimage.image = data;
            setprocessedimage([...filteredprocessimage]);   
            var  filterorderedprocessedimage = orderedprocessedimage;
            filterorderedprocessedimage.forEach(element => {
                if (element.refid == (referenceid.replace(".jpeg",""))) {
                    element.image = data;
                }
            });
            // var  filterorderedprocessedimage = orderedprocessedimage.filter(function (entry) { return entry.refid == (referenceid.replace(".jpeg","")); });
            // filterorderedprocessedimage.image = data;
            setorderedprocessedimage([...filterorderedprocessedimage]);
            });
            var filtereduploadedfile = uploadedfile;
            filtereduploadedfile.forEach(element => {
                if (element.identity == (referenceid.replace(".jpeg",""))) {
                    element.binaryfile = file;
                    element.identity = newfilename.replace(".jpeg","");
                }
            });
            // var filtereduploadedfile = uploadedfile.filter(function (entry) { return entry.identity == (referenceid.replace(".jpeg","")); });
            // filtereduploadedfile.image = data;
            setuploadedfile([...filtereduploadedfile]);
    }
    function getBase64(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
        });
      }

    const uploadsingleimagestoserver=(file,processid,name)=>{
        // var lielementtemp = document.getElementById(name.split('.').join('_'));
        // var roomtypetext = lielementtemp.getElementsByTagName('h4')[0].innerText;
        // var existroomtypes = roomtypes.filter(x=> x.name == roomtypetext);
        // if (existroomtypes != undefined && existroomtypes.length > 0) {
        //     existroomtypes[0].count += 1;
        // }
        const axios = require('axios');
        const FormData = require('form-data');
        // const fs = require('fs');
        showoverlaytwo();
        let data = new FormData();
        data.append('uid', '3a2ab8ee-5264-4a8a-895b-bbcbb96882e0');
        data.append('companyid', '15');
        data.append('files', file);
        data.append('processid', processid);
        data.append('name', name);
        if (file == undefined || file == null)
        {
            customAlertMessage('error','Please select files and proceed');
            document.getElementById('upload_div').style.display ="block";
            document.getElementById('main_div').style.display = "none";
            return;
        }
        let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}` +'/api/ArtificialIntelligence/uploadmlscomplianceimages_s_h',
        //url: 'https://localhost:44372/api/ArtificialIntelligence/uploadmlscomplianceimages_s_h',
        data : data
        };

        axios.request(config)
        .then((response) => {
            // console.log(JSON.stringify(response.data));
            var Responsedata = response.data.Data;
            if (Responsedata != "" && Responsedata != null) {
                var tempuploadedimagearrayempty = [];
                var tempuploadedimages = uploadedimages;
                tempuploadedimages.forEach(element => {
                    if (element.image == name) {
                        element.image = Responsedata;                        
                        if (response.data.Message == "duplicate") {
                            element.processed = "1";
                            element.compliant = "0";
                            // element.editpermission = 2;
                            element.spacetype = "Duplicate image.";    
                            element.editpermission = 1;
                            element.description = "";                            
                        }
                        else{
                            element.processed = "0";
                            element.compliant = "-1";
                        }
                        replacefile(name,file,Responsedata);                        
                    }
                });
                setuploadedimages(upimage => [...tempuploadedimagearrayempty,...tempuploadedimages]);
                    // var tempuploadedimagearray = uploadedimages.filter(x=>x.image != name);
                    // var tempuploadedimagearray11 = [];
                    // if (tempuploadedimagearray != undefined) {
                    //     var imagejson = {};
                    //     imagejson.image = Responsedata;
                    //     imagejson.processed = "-1";
                    //     imagejson.compliant = "-1";
                    //     tempuploadedimagearray11.push(imagejson);
                    // }
                    // setuploadedimages(upimage => [...tempuploadedimagearray,...tempuploadedimagearray11]);
                    hideoverlaytwo();
                // var lielement = document.getElementById(name.split('.').join('_'));
                // lielement.getElementsByTagName('img')[0].src = localimagebasepath + processid + "/" + Responsedata;
                  setTimeout(() => {                    
                    if (response.data.Message != "duplicate") {
                        processcompliance_s_i(processid,Responsedata);
                    }
                    // processroomtypes_s_i(processid,Responsedata);
                }, 1000);
                // var tempuploadedimages = Responsedata.imagelist;
                // setuploadedimages(upimage => [...upimage , ...tempuploadedimages])
                // setprocessid(Responsedata.processid);
                // hideoverlaytwo();
                // setTimeout(() => {                    
                //     processroomtypes(Responsedata.processid);
                // }, 1000);
            }
            else{
                customAlertMessage('error','Something went wrong, Please try again.');
                document.getElementById('upload_div').style.display ="block";
                document.getElementById('main_div').style.display = "none";
                hideoverlaytwo();
            }
            
        })
        .catch((error) => {
            console.log(error);
            customAlertMessage('error','Something went wrong, Please try again.');
            document.getElementById('upload_div').style.display ="block";
            document.getElementById('main_div').style.display = "none";
            hideoverlaytwo();
        });

    }
    // const processroomtypes=(processidparam)=>{
    //     const axios = require('axios');
    //     const FormData = require('form-data');
    //     showoverlay();
    //     setanalyzingroomtype(true);
    //     let data = new FormData();
    //     data.append('processid',(processid == ""?processidparam: processid));
    //     let config = {
    //     method: 'post',
    //     maxBodyLength: Infinity,
    //     url: `${process.env.REACT_APP_API_URL}` +'/api/ArtificialIntelligence/imagecaption',        
    //     data : data
    //     };

    //     axios.request(config)
    //     .then((response) => {
    //     console.log(JSON.stringify(response.data));
    //     var DATA = response.data.Data;
    //     var resultroomtypes = [];
    //     if (DATA != null && DATA != "") {
    //         var results = DATA;
    //         setimagecaption(results);
    //         results.forEach(element => {
    //             var lielement = document.getElementById(element.imagename.split('.').join('_'));
    //             lielement.getElementsByTagName('h4')[0].innerText = (element.roomtype);
    //             lielement.getElementsByTagName('p')[0].innerText = (element.description);
    //             var roomjson = {};
    //             var existroomtypes = resultroomtypes.filter(x=> x.name == element.roomtype);
    //             if (existroomtypes != undefined && existroomtypes.length > 0) {
    //                 existroomtypes[0].count += 1;
    //             }
    //             else{
    //                 roomjson.name = element.roomtype;
    //                 roomjson.count = 1;
    //                 resultroomtypes.push(roomjson);
    //             }                
    //         });
    //         setroomtypes(room => [...room,...resultroomtypes]);
    //         setanalyzingroomtype(false);
            
    //     }
    //     else{
    //         customAlertMessage('error','Something went wrong, Please try again.');
    //         setanalyzingroomtype(null);
    //     }
    //     hideoverlay();
    //     })
    //     .catch((error) => {
    //         customAlertMessage('error','Something went wrong, Please try again.');
    //         console.log(error);
    //         setanalyzingroomtype(null);
    //         hideoverlay();
    //     });

    // }
    // const processcompliance=(processidparam)=>{
    //     const axios = require('axios');
    //     const FormData = require('form-data');
    //     showoverlaypropcomp();
    //     // setcompliancepassed(false);
    //     let data = new FormData();
    //     data.append('processid',(processid == ""?processidparam: processid));
    //     let config = {
    //     method: 'post',
    //     maxBodyLength: Infinity,
    //     url: `${process.env.REACT_APP_API_URL}` +'/api/ArtificialIntelligence/imagecompliance',        
    //     data : data
    //     };

    //     axios.request(config)
    //     .then((response) => {
    //     console.log(JSON.stringify(response.data));
    //     var DATA = response.data.Data;
    //     var resultroomtypes = [];
    //     if (DATA != null && DATA != "") {
    //         var compliancepassed = DATA.compliancepassed;
    //         // setcompliancepassed(compliancepassed);
    //         if (compliancepassed == false) {
                
    //         }
    //         var results = DATA.list;
    //         // setimagecaption(results);
    //         // results.forEach(element => {
    //         //     var lielement = document.getElementById(element.imagename.split('.').join('_'));
    //         //     lielement.getElementsByTagName('h4')[0].innerText = (element.roomtype);
    //         //     lielement.getElementsByTagName('p')[0].innerText = (element.description);
    //         //     var roomjson = {};
    //         //     var existroomtypes = resultroomtypes.filter(x=> x.name == element.roomtype);
    //         //     if (existroomtypes != undefined && existroomtypes.length > 0) {
    //         //         existroomtypes[0].count += 1;
    //         //     }
    //         //     else{
    //         //         roomjson.name = element.roomtype;
    //         //         roomjson.count = 1;
    //         //         resultroomtypes.push(roomjson);
    //         //     }                
    //         // });

    //         // setroomtypes(room => [...room,...resultroomtypes]);
            
    //     }
    //     else{
    //         customAlertMessage('error','Something went wrong, Please try again.');
    //     }   
    //     // setanalyzingroomtype(false);
    //     updateProgressBartoend()
    //     setTimeout(() => {
    //         hideoverlaypropcomp();    
    //     }, 2000);
        
    //     })
    //     .catch((error) => {
    //         customAlertMessage('error','Something went wrong, Please try again.');
    //         console.log(error);
    //         updateProgressBartoend();
    //         hideoverlaypropcomp();
    //     });

    // }

    const processroomtypes_s_i=(processidparam,imageidentity)=>{
        const axios = require('axios');
        const FormData = require('form-data');
        // showoverlay();
        // setanalyzingroomtype(true);
        let data = new FormData();
        data.append('processid',(processid == ""?processidparam: processid));
        data.append('name',imageidentity);
        let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}` +'/api/ArtificialIntelligence/imagecaption_s_i',  
        // url: 'https://localhost:44372/api/ArtificialIntelligence/imagecaption_s_i',        
        data : data
        };

        axios.request(config)
        .then((response) => {
        // console.log(JSON.stringify(response.data));
        var DATA = response.data.Data;
        var resultroomtypes = [];
        if (roomtypes.length > 0) {
            resultroomtypes = roomtypes;
        }
        if (DATA != null && DATA != "") {
            var results = DATA;
            // setimagecaption(results);
            results.forEach(element => {
                // var lielement = document.getElementById(element.imagename.split('.').join('_'));
                var roomtype = element.roomtype == "error" ? "Unidentified Spaces" : element.roomtype;
                var roomdescription = element.description == "error" ? "" : element.description;
                var condition = element.condition;
                // lielement.getElementsByTagName('h4')[0].innerText = (roomtype);
                // lielement.getElementsByTagName('p')[0].innerText = (roomdescription);
                
                // var existroomtypes = resultroomtypes.filter(x=> x.name == element.roomtype);
                // if (existroomtypes != undefined && existroomtypes.length > 0) {
                //     existroomtypes[0].count += 1;
                // }
                // else{
                //     var roomjson = {};
                //     roomjson.name = element.roomtype;
                //     roomjson.count = 1;
                //     resultroomtypes.push(roomjson);
                // }                
                var tempuploadedimages = uploadedimages;
                var tempuploadedimagearray = tempuploadedimages.find(x=>x.image == element.imagename);
                if (tempuploadedimagearray != undefined) {
                        if (roomtype == "Non-Compliant_front_view") {
                            tempuploadedimagearray.compliant = "0";
                            tempuploadedimagearray.processed = "1";
                            // tempuploadedimagearray.spacetype = roomtype;
                            // tempuploadedimagearray.description = roomdescription;
                            //tempuploadedimagearray.editpermission = 3; // no edit option. only ignore / remove / replace
                            tempuploadedimagearray.spacetype = roomtype;
                            tempuploadedimagearray.description = roomdescription;
                            tempuploadedimagearray.editpermission = 1;
                            tempuploadedimagearray.condition = condition;
                        }
                        else{
                            tempuploadedimagearray.processed = "1";
                            tempuploadedimagearray.spacetype = roomtype;
                            tempuploadedimagearray.description = roomdescription;
                            tempuploadedimagearray.editpermission = 0;
                            tempuploadedimagearray.condition = condition;
                            addtoulphotobreak(roomtype,element.imagename);
                        }

                    
                }
                setuploadedimages([...tempuploadedimages]);
            });
            // var _room = [];
            // setroomtypes(room => [...room,...resultroomtypes]);
            // setroomtypes([...resultroomtypes]);
            // setanalyzingroomtype(false);
            // processcompliance_s_i(processidparam,imageidentity);
            setTimeout(() => {                    
                // processroomtypes(Responsedata.processid);
                startprocess_single();
            }, 1000);
            
        }
        else{
            customAlertMessage('error','Something went wrong, Please try again.');
            // setanalyzingroomtype(null);
            setTimeout(() => {                    
                // processroomtypes(Responsedata.processid);
                startprocess_single();
            }, 1000);
        }
        hideoverlay();
        })
        .catch((error) => {
            customAlertMessage('error','Something went wrong, Please try again.');
            console.log(error);
            // setanalyzingroomtype(null);
            setTimeout(() => {                    
                // processroomtypes(Responsedata.processid);
                startprocess_single();
            }, 1000);
            hideoverlay();
        });

    }
    const processcompliance_s_i=(processidparam,imageidentity)=>{
        const axios = require('axios');
        const FormData = require('form-data');
        let data = new FormData();
        data.append('processid',(processid == ""?processidparam: processid));
        data.append('name',imageidentity);
        data.append('uid',UserID);
        data.append('companyid',Companyid);
        let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}` + '/api/ArtificialIntelligence/imagecompliance_s_i',
        // url: 'https://localhost:44372/api/ArtificialIntelligence/imagecompliance_s_i',        
        data : data
        };

        axios.request(config)
        .then((response) => {
        // console.log(JSON.stringify(response.data));
        var DATA = response.data.Data;
        var resultroomtypes = [];
        if (DATA != null && DATA != "") {
            var compliancepassed = DATA.compliancepassed;
            var results = DATA.list;
            if (compliancepassed == false) {
                results.forEach(element => {
                    var tempuploadedimages = uploadedimages;
                    var tempuploadedimagearray = tempuploadedimages.find(x=>x.image == element.imagename);
                    if (tempuploadedimagearray != undefined) {  
                        if (element.watermark == true || element.watermark == "true") {
                            tempuploadedimagearray.compliant = "0";
                            tempuploadedimagearray.processed = "1";                            
                            tempuploadedimagearray.spacetype = "Watermark/Copyright found."
                            // tempuploadedimagearray.editpermission = 2;
                            tempuploadedimagearray.description = "";
                            tempuploadedimagearray.editpermission = 1;
                        }                      
                        else if(element.description.trim().toLowerCase() == "copyright image."){
                            tempuploadedimagearray.compliant = "0";
                            tempuploadedimagearray.processed = "1";
                            // tempuploadedimagearray.compliancefailedimage = element.outputurl;
                            // tempuploadedimagearray.compliancefailedimagefordeclutter = element.srcimgurl;
                            // tempuploadedimagearray.compliancefailedimagemask = element.maskurl;
                            // tempuploadedimagearray.sourceimageheight = element.srcImgH;
                            // tempuploadedimagearray.sourceimagewidth = element.srcImgW;
                            tempuploadedimagearray.spacetype = element.description.trim() == "cuda error" ? "Image error" : element.description.trim(); // roomdescription;
                            tempuploadedimagearray.description = element.maskurl;
                            tempuploadedimagearray.editpermission = 0;
                        }
                        else if (element.description.trim() == "cuda error" && parseInt(tempuploadedimagearray.nooftries) <= 0) {
                            tempuploadedimagearray.nooftries = parseInt(tempuploadedimagearray.nooftries) +1;
                            tempuploadedimagearray.processed = "-10";
                        }
                        else{
                            // console.log("description",element.description);
                            // console.log("tempuploadedimagearray",parseInt(tempuploadedimagearray.nooftries));
                            tempuploadedimagearray.compliant = "0";
                            tempuploadedimagearray.processed = "1";
                            tempuploadedimagearray.compliancefailedimage = element.outputurl;
                            tempuploadedimagearray.compliancefailedimagefordeclutter = element.srcimgurl;
                            tempuploadedimagearray.compliancefailedimagemask = element.maskurl;
                            tempuploadedimagearray.sourceimageheight = element.srcImgH;
                            tempuploadedimagearray.sourceimagewidth = element.srcImgW;
                            tempuploadedimagearray.spacetype = element.description.trim() == "cuda error" ? "Image error" : element.description.trim(); // roomdescription;
                            tempuploadedimagearray.description = "";
                            tempuploadedimagearray.editpermission = 1;
                            // var lielement = document.getElementById(element.imagename.split('.').join('_'));
                            // lielement.getElementsByTagName('p')[1].innerText = (element.description);
                        }
                        
                    }
                    setuploadedimages([...tempuploadedimages]);


                    // var lielement = document.getElementById(element.imagename.split('.').join('_'));
                    // lielement.classList.add("errorcomplaince");
                });
                    setTimeout(() => {
                        startprocess_single();
                    }, 1000);
            }
            else{
                results.forEach(element => {
                    var tempuploadedimages = uploadedimages;
                    var tempuploadedimagearray = tempuploadedimages.find(x=>x.image == element.imagename);
                    if (tempuploadedimagearray != undefined) {
                        tempuploadedimagearray.compliant = "1";
                        tempuploadedimagearray.processed = "0";
                    }
                    setuploadedimages([...tempuploadedimages]);
                    processroomtypes_s_i(processid,imageidentity);
                    // var lielement = document.getElementById(element.imagename.split('.').join('_'));
                    // lielement.classList.remove("errorcomplaince");
                });
            }

            // setimagecaption(results);
            // results.forEach(element => {
            //     var lielement = document.getElementById(element.imagename.split('.').join('_'));
            //     lielement.getElementsByTagName('h4')[0].innerText = (element.roomtype);
            //     lielement.getElementsByTagName('p')[0].innerText = (element.description);
            //     var roomjson = {};
            //     var existroomtypes = resultroomtypes.filter(x=> x.name == element.roomtype);
            //     if (existroomtypes != undefined && existroomtypes.length > 0) {
            //         existroomtypes[0].count += 1;
            //     }
            //     else{
            //         roomjson.name = element.roomtype;
            //         roomjson.count = 1;
            //         resultroomtypes.push(roomjson);
            //     }                
            // });

            // setroomtypes(room => [...room,...resultroomtypes]);
            
        }
        else{
            customAlertMessage('error','Something went wrong, Please try again.');
            setTimeout(() => {                    
                // processroomtypes(Responsedata.processid);
                startprocess_single();
            }, 1000);
        }   
        // setanalyzingroomtype(false);
        // updateProgressBartoend()
        // setTimeout(() => {
        //     hideoverlaypropcomp();    
        // }, 2000);
        
        })
        .catch((error) => {
            customAlertMessage('error','Something went wrong, Please try again.');
            console.log(error);
            setTimeout(() => {                    
                // processroomtypes(Responsedata.processid);
                startprocess_single();
            }, 1000);
            // updateProgressBartoend();
            // hideoverlaypropcomp();
        });

    }
// function showoverlaypropcomp() {
//     document.getElementById('compliancecheck').style.display = "flex";
//     document.getElementById('imagesdiv').style.display = "none";
//     $('body').addClass("loader");
//     updateProgressBar(uploadedimages.length);
// }
// function hideoverlaypropcomp(){
//     document.getElementById('compliancecheck').style.display = "none";
//     document.getElementById('imagesdiv').style.display = "block";
//     $('body').removeClass("loader");    
// }

function updateProgressBartoend() {
    var progressbar = document.querySelectorAll('.progress-bar');
    progressbar.forEach(element => {
        const progressBarElement = element;
        progressBarElement.style.width = '100%';
    });    
}

function updateProgressBar(numberOfImages) {
    // Assuming each image takes an average of 4 seconds to load
    const averageTimePerImage = 10000; // in milliseconds
    const totalTime = numberOfImages * averageTimePerImage;
    var progressbar = document.querySelectorAll('.progress-bar');
    progressbar.forEach(element => {
        // const progressBarElement = element;
        updateSingleProgressBar(element, numberOfImages)
        // let currentTime = 0;
        // // Interval to update the progress bar every 100 milliseconds
        // const interval = setInterval(function () {
        //     // Calculate the percentage of the total time that has passed
        //     const percentage = (currentTime / totalTime) * 100;
        //     progressBarElement.style.width = percentage + '%';

        //     // Increment the current time
        //     currentTime += 100;

        //     // If the total time has passed, clear the interval
        //     if (currentTime >= totalTime) {
        //         clearInterval(interval);
        //         progressBarElement.style.width = '100%'; // Ensure the bar is fully filled
        //     }
        // }, 100);
    });    
}

function updateSingleProgressBar(progressBarElement, numberOfImages) {
    // Assuming each image takes an average of 4 seconds to load
    const averageTimePerImage = 10000; // in milliseconds
    const totalTime = numberOfImages * averageTimePerImage;
    let currentTime = 0;

    // Interval to update the progress bar every 100 milliseconds
    const interval = setInterval(function () {
        // Calculate the percentage of the total time that has passed
        const percentage = (currentTime / totalTime) * 100;
        progressBarElement.style.width = percentage + '%';
        progressBarElement.innerText = Math.round(percentage) + '%';

        // Increment the current time
        currentTime += 100;

        // If the total time has passed, clear the interval
        if (currentTime >= totalTime) {
            clearInterval(interval);
            progressBarElement.style.width = '100%'; // Ensure the bar is fully filled
            // progressBarElement.innerText = '100%';
        }
    }, 100);
}
    
function showoverlayprop() {
    document.getElementById('newloaderprop').style.display = "flex";
    document.getElementById('main_div').style.display = "none";
    $('body').addClass("loader");
}
function hideoverlayprop(){
    document.getElementById('newloaderprop').style.display = "none";
    document.getElementById('main_div').style.display = "flex";
    $('body').removeClass("loader");
}

const generateaicontentCounters=()=>{        
    document.getElementById("divGeneratedContent").innerHTML="description start";
    try {
        document.getElementById("plagiarisminfo").style.display = "none";
    } catch (error) {
        
    }    
    document.getElementById("divGeneratedContent").innerHTML="";
    // document.getElementById("h4Title").innerHTML="";
    document.getElementById("spanCharCount").style.display = "none";
    document.getElementById("divOutputIcons").style.display = "none";
    showoverlayprop();
    setlistingdescriptionstatus(0);
    var prompt = "";        
    var txtPropAddress = document.getElementById('txtPropAddress').value;
    prompt = "Generate detailed property listing description for "+txtPropAddress +". ";    

    // step 2 start ==>Property details
    var propTypeSel = document.getElementById("ddlPropertyType").value;
    if (propTypeSel != "select") {
        prompt += " with " + propTypeSel +" propertytype.";
    }
    else{
        prompt +=".";
    }
    var ddlBedroomsSel = document.getElementById("ddlBedrooms").value;
    if (ddlBedroomsSel != "select") {
        prompt += " It has "+ ddlBedroomsSel + " number of bedrooms and " ;
    }
    var ddlBathroomsSel = document.getElementById("ddlBathrooms").value;
    if (ddlBathroomsSel != "select") {
        prompt +=  ddlBathroomsSel + " number of bathrooms." ;
    }
    var ddlFloorsSel = document.getElementById("ddlFloors").value;
    if (ddlFloorsSel != "select") {
        prompt += " It is a " + ddlFloorsSel + " story home." ; 
    }
    var txtAreaSel = document.getElementById("txtArea").value;
    if (txtAreaSel != "") {
        prompt += "It is having an area of "+txtAreaSel+ " sqft.";
    }
    // lot size comented
    // var txtAreaSel = document.getElementById("txtArea").value; 
    // if (txtAreaSel != "") {
    //     prompt += "and "+txtAreaSel+ " lot size.";
    // }  
    var ddlGaragetypeSel = document.getElementById("ddlGaragetype").value;
    var ddlGaragespacesSel = document.getElementById("ddlGaragespaces").value;
    if (ddlGaragetypeSel !="select" && ddlGaragespacesSel != "select") {
        prompt += " It has " + ddlGaragetypeSel + " garage with "+ ddlGaragespacesSel + " spaces."; 
    }
    else if (ddlGaragetypeSel != "select") {
        prompt += " It has " + ddlGaragetypeSel + " garage." ; 
    }
    else if (ddlGaragespacesSel != "select") {
        prompt += " It has " + ddlGaragespacesSel + " garage." ; 
    }
    // prompt += "The property most Saleable features include ";
    // var txtMostSalableSel = document.getElementById("txtMostSalable").value;
    // if (txtMostSalableSel != "") {
    //     prompt += txtMostSalableSel + ".";
    // }
    // Step 2 end

    // step 1 start ==>Amenitinies
        
        //school amenity 
        var markedCheckbox = document.getElementsByName('schoolAmenity');  
        var schoolAmenitiesel = "";
        for (var checkbox of markedCheckbox) {  
            if (checkbox.checked)  {
                var lblIds = checkbox.id.replace("chkschool","lblschool");
                schoolAmenitiesel += document.getElementById(lblIds).innerText + ', ';
            }
        } 
        if (schoolAmenitiesel !="") {
            prompt += "The property has near by schools including " + schoolAmenitiesel + ".";
        }
    
        var markedCheckboxHosp = document.getElementsByName('hospitalAmenity');  
        var hospitalAmenitiesel = "";
        for (var checkbox of markedCheckboxHosp) {  
            if (checkbox.checked)  {
                var lblIdshospital = checkbox.id.replace("chkhospital","lblhospital");
                hospitalAmenitiesel += document.getElementById(lblIdshospital).innerText + ', ';
            }
        } 
        if (hospitalAmenitiesel !="") {
            prompt += "The property has near by hospitals including " + hospitalAmenitiesel + ".";
        }
    
        var markedCheckboxpark = document.getElementsByName('parkAmenity');  
        var parkAmenitiesel = "";
        for (var checkbox of markedCheckboxpark) {  
            if (checkbox.checked)  {
                var lblIdspark = checkbox.id.replace("chkpark","lblpark");
                parkAmenitiesel += document.getElementById(lblIdspark).innerText + ', ';
            }
        } 
        if (parkAmenitiesel !="") {
            prompt += "The property has near by parks including " + parkAmenitiesel + ".";
        }
    
        var markedCheckboxsupermarket = document.getElementsByName('supermarketAmenity');  
        var supermarketAmenitiesel = "";
        for (var checkbox of markedCheckboxsupermarket) {  
            if (checkbox.checked)  {
                var lblIdssupermarket = checkbox.id.replace("chksupermarket","lblsupermarket");
                supermarketAmenitiesel += document.getElementById(lblIdssupermarket).innerText + ', ';
            }
        } 
        if (supermarketAmenitiesel !="") {
            prompt += "The property has near by supermarkets including " + supermarketAmenitiesel + ".";
        }
    
        // Step 1 end

    // prompt += getroomtypebreakdown() + " The property special features were ";


    prompt += " The property special features were "
    prompt += getroomfeatures();
    prompt += ". Also include headline note on header and call to action at the end of the description.";
    prompt +=" Make description paragraph wise."

    // console.log(prompt);
    var lengthcontroller = "2000";//this.getselectedcontentlength();
    var Supplement = "";//this.gettexteleValue("textareaoutput", "Supplement");
    var toneofvoice = "";//this.gettexteleValue("toneofvoice", "Tone");
    var keywords = "";//this.gettexteleValue("keywordinput", "Keyword");
    var prompttext = (prompt);    
    var axios = require("axios");
    
    const FormData = require('form-data');
    var tokens = 4000;
    let data = new FormData();
    data.append('prompt', prompttext.trim());
    data.append('uid', (Role == 3 ? MasterId : UserID));
    data.append('cid', Companyid);
    data.append('token', tokens);

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}`+'/api/ArtificialIntelligence/GetGroqResponse',       
        data : data
    };

    axios(config)
      .then(function (resp) {
        var response = resp.data;
        if (resp != null && response != "" && response.Data !="") {
          var datalist = response.Data.split('\n');          
          var finalData="";
          for(var i=0;i<datalist.length;i++)
          {
              if(datalist[i]!="")
              {
                finalData = finalData +datalist[i] +"\n";
              }
          }
        //   hideoverlay();      
        //   //window.scrollTop = document.body.scrollHeight;
          $("html, body").animate({ scrollTop: document.body.scrollHeight }, "slow");
          t = 0;  
          finalData = finalData.replace("Headline: ","").replace("Headline:","").replace("headline: ","").replace("Paragraph 1:","").replace("Paragraph 2:","").replace("Paragraph 3:","").replace("Paragraph 4:","").replace("Paragraph 5:","").replace("Paragraph 6:","");
          finalData = finalData.replace("Call to Action: ","").replace("Headline note:","").replace("Headline Note:","");       
          var divOuterContent = document.getElementById('divOuterContent');
          divOuterContent.scrollTop =  divOuterContent.scrollHeight; 
          //typeWriter(finalData);
          document.getElementById("lblCcount").innerHTML= finalData.length;
            finalData = finalData.replace(/\n/g,"<p class='word-break:break-word;'></p>");
            document.getElementById("divGeneratedContent").innerHTML=finalData;
          document.getElementById('divGeneratedContent').contentEditable ="true";
          document.getElementById("divOutputIcons").style.display = "block";
          document.getElementById("spanCharCount").style.display = "block";
        }        
        hideoverlayprop();
        setlistingdescriptionstatus(1);
      })
      
      .catch(function (error) {
        console.log(error);
        hideoverlayprop();
        setlistingdescriptionstatus(2);
        //document.getElementById("newloaderprop").style.display="none";
        customAlertMessage(
          "error",
          "Something went wrong, please try again."
        );
      });
  }
  const typeWriter =(datalist,Dataobjects)=> {    
    var speed = 10;
    if (t < datalist.length) {        
        var textLst = datalist.charAt(t);
        document.getElementById("divGeneratedContent").innerHTML += textLst=== "\n" ? "<p></p>": textLst;
        t++;
        document.getElementById("lblCcount").innerHTML= t;
        setTimeout(function(){typeWriter(datalist,Dataobjects)}, speed);
        //window.scrollTo(0, document.body.scrollHeight);
        var elementsDiv1 = document.getElementById("divGeneratedContent");
        elementsDiv1.scrollTop = elementsDiv1.scrollHeight;               
    }
    if(t + 1 ==  datalist.length){
        console.log('inside final');
        document.getElementById("divOutputIcons").style.display = "block";
        // Highlightkeys(Dataobjects);

    }
}
function showoverlay4() {
    document.getElementById('overlayloader4').style.display = "block";
    $('body').addClass("loader");
}
function hideoverlay4(){
    document.getElementById('overlayloader4').style.display = "none";
    $('body').removeClass("loader");
}
function Checkplagiarism() {
    try {
      if (document.getElementById("divGeneratedContent").innerText == "") { 
        this.customAlertMessage(
          "warning",
          "cannot check plagiarism for empty content."
        );
        return;
      }
    } catch (error) {
      this.customAlertMessage("error", "Error occured, Please try again.");
      return;
    }

    showoverlay4();

    var axios = require("axios");
    var FormData = require("form-data");
    var data = new FormData();
    data.append(
      "postdata",
      document.getElementById("divGeneratedContent").innerText.trim()
    );
    data.append("uid",(Role == 3 ? MasterId : UserID));
    data.append("companyid",Companyid);

    var config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}` +"/api/ArtificialIntelligence/checkduplicatebyformdata",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (resp) {
        var response = resp.data;
        if (response.Data != null) {
          if (response.Data.count != null && response.Data.count === 0) {
            customAlertMessage("success", "No plagiarism found");
            document.getElementById("plagiarisminfo").style.display = "none";
            // document.getElementById("plagiarismmodalbody").innerHTML = "";
            setplagiarismmodalbody({ __html: '' });
            // $(elem).find('.checkmark').show();
            // $(elem).find('.ban').hide();
            // $(elem).attr('tooltip', "No plagiarism found.");
            // $(elem).attr('onclick', "return false;");
          } else if (response.Message == "small content") {
            customAlertMessage("info", response.Data);
          } else {
            document.getElementById("plagiarisminfo").innerText =
              response.Data.count + " copies found";
            document.getElementById("plagiarisminfo").style.display =
              "inline-block";
            var htmlnew = duplicateresultcontent;
            htmlnew = htmlnew.replace("[PHCScount]", response.Data.count);
            htmlnew = htmlnew.replace(
              "[PHCSquerywords]",
              response.Data.querywords
            );
            var duplicateresultparagraphlist = "";
            for (var i = 0; i < response.Data.count; i++) {
              var result = response.Data.result[i];
              var duplicateresultparacontent =
                duplicateresultparacontenttemplate;
              duplicateresultparacontent = duplicateresultparacontent.replace(
                "[PHCSurl]",
                result.url
              );
              duplicateresultparacontent = duplicateresultparacontent.replace(
                "[PHCSurltext]",
                result.url
              );
              duplicateresultparacontent = duplicateresultparacontent.replace(
                "[PHCStitle]",
                result.title
              );
              duplicateresultparacontent = duplicateresultparacontent.replace(
                "[PHCShtmlsnippet]",
                result.textsnippet
              );
              duplicateresultparagraphlist =
                duplicateresultparagraphlist + duplicateresultparacontent;
            }
            htmlnew = htmlnew.replace(
              "[PHCSparagraphlist]",
              duplicateresultparagraphlist
            );
            // document.getElementById("plagiarismmodalbody").innerHTML = htmlnew;
            setplagiarismmodalbody({ __html:htmlnew});
            customAlertMessage("error", "Plagiarism found");
          }
        } else {
          customAlertMessage("error", "Error occured, Please try again."); // 'success','failure','info'
        }
        hideoverlay4();
      })
      .catch(function (error) {
        //console.log(error);
        customAlertMessage("error", "Something went wrong, Try Again.");
        hideoverlay4();
      });
  };

  const showthirdstep=()=>{
    var filteredarray = [...document.querySelectorAll('.mlsright li')].filter(el => (el.dataset.processed == "0" || el.dataset.processed == "-1"));
    if (filteredarray.length > 0) {
        customAlertMessage("error", "Please wait while we are processing the images.");
        // var filteredprocessingarray = [...document.querySelectorAll('.mlsright li')].filter(el => (el.dataset.processed == "0"));
        // if (filteredprocessingarray.length <= 0) {
            
        // }
        return;
    }
    document.getElementById('imagesdiv').style.display = 'none';
    document.getElementById('divpropertydetails').style.display = 'block';
    document.getElementById('div3').classList.remove('inactive');
    // var txtPropAddress = document.getElementById('txtPropAddress').value;
    // if (txtPropAddress.trim() === "") {
    //     customAlertMessage('error', 'Please enter property address.');
    //     return;
    // }
    // generateaicontentCounters();
  }

  const generatecontentfromdescription=()=>{    
    // var txtPropAddress = document.getElementById('txtPropAddress').value;
    // if (txtPropAddress.trim() === "") {
    //     customAlertMessage('error', 'Please enter property address.');
    //     return;
    // }
    // validatePropertyDetails();
    var propTypeSel = document.getElementById("ddlPropertyType").value;
    if (propTypeSel == "select") {
        customAlertMessage('error', 'Please select property type.');
        setTimeout(() => {
            document.getElementsByClassName('prop-top-title')[0].scrollIntoView();    
        }, 1000);
        return false;
    }
    var ddlBedrooms = document.getElementById("ddlBedrooms").value;
    if(ddlBedrooms == "select"){
        customAlertMessage('error', 'Number of bedrooms is required.');
        setTimeout(() => {
            document.getElementsByClassName('prop-top-title')[0].scrollIntoView();    
        }, 1000);
        return false;
    }
    var ddlBathrooms = document.getElementById("ddlBathrooms").value;
    if(ddlBathrooms == "select"){
        customAlertMessage('error', 'Number of bathrooms is required.');
        setTimeout(() => {
            document.getElementsByClassName('prop-top-title')[0].scrollIntoView();    
        }, 1000);
        return false;
    }
    var ddlFloors = document.getElementById("ddlFloors").value;
    if(ddlFloors == "select"){
        customAlertMessage('error', 'Number of floors is required.');
        setTimeout(() => {
            document.getElementsByClassName('prop-top-title')[0].scrollIntoView();    
        }, 1000);
        return false;
    }
    var txtArea = document.getElementById("txtArea").value;
    if(txtArea == ""){
        customAlertMessage('error', 'Floor area is required.');
        setTimeout(() => {
            document.getElementsByClassName('prop-top-title')[0].scrollIntoView();    
        }, 1000);        
        return false;
    }
    document.getElementById('divpropertydetails').style.display = 'none';
    document.getElementById('editordiv').style.display = 'block';
    document.getElementById('div4').classList.remove('inactive');
    generateaicontentCounters();
    
  }

  const getroomtypebreakdown=()=>{
    var photobreakli = document.querySelectorAll('.photobreak li');
    var roomtypetext = "";
    photobreakli.forEach((element, idx, array) => {
        var photobreaklispan = element.getElementsByTagName('span');
        if (photobreaklispan.length > 0) {
            roomtypetext  += "It has a "+ photobreaklispan[1].innerText+ " "+ photobreaklispan[0].innerText +", ";
            if (idx !== array.length - 1){ 
                roomtypetext  +=", ";
            }
        }
    });
    return roomtypetext;
  }

  const getroomfeatures=()=>{
    var roomfeaturestext = "";
    // var SummaryTool = require('node-summary');
    try {
        var photobreak = document.querySelectorAll('.photobreak li span:first-child');
        photobreak.forEach(element => {
            var categorytext = "";
            var filteredheading = Array.from(document.querySelectorAll('.mlsright li:not(.errorcomplaince) .validcompliance h4')).filter(item => item.innerText.includes(element.innerText));
            if (filteredheading.length > 0) {
                var filteredheadingfirst = filteredheading[0];
                categorytext += filteredheadingfirst.parentElement.getElementsByTagName('p')[0].innerText;
                // filteredheading.forEach(element => {
                //     categorytext += element.parentElement.getElementsByTagName('p')[0].innerText;
                // });
                
                // SummaryTool.summarize(element.innerText, categorytext, function(err, summary) {
                //     if(err) console.log("Something went wrong man!");   

                //     console.log(summary);
                //     roomfeaturestext  += categorytext + ", ";

                //     // console.log("Original Length " + (title.length + content.length));
                //     // console.log("Summary Length " + summary.length);
                //     // console.log("Summary Ratio: " + (100 - (100 * (summary.length / (title.length + content.length)))));
                // });
            }
            roomfeaturestext  += categorytext + ", ";
        });

        // var photobreakli = document.querySelectorAll('.mlsright li:not(.errorcomplaince)');// document.querySelectorAll('.mlsright li');    
        // photobreakli.forEach((element, idx, array) => {
        //     var photobreaklipara = element.getElementsByTagName('p');
        //     if (photobreaklipara.length > 0) {
        //         roomfeaturestext  += photobreaklipara[0].innerText;
        //         if (idx !== array.length - 1){ 
        //             roomfeaturestext  +=", ";
        //         }
        //     }
        // });
    } catch (error) {
        
    }    
    return roomfeaturestext;
  }

  const comingsoon =()=>{
    customAlertMessage('info','We are working on it, Coming Soon.');
  }




  const ignorecompliance=(e)=>{
    var imageidentity = e.currentTarget.dataset.filerefid;
    var editpermission = e.currentTarget.dataset.editpermission;
    var spacetype = e.currentTarget.dataset.spacetype;
    if (parseInt(editpermission) == 2) {
        customAlertMessage('error','Ignore compliance is not allowed for this image.');
        return;
    }
    if (spacetype.trim() == "Non-Compliant_front_view") {
        var tempuploadedimages = uploadedimages;
        var tempuploadedimagearray = tempuploadedimages.find(x=>x.image == imageidentity);
        if (tempuploadedimagearray != undefined) {        
            tempuploadedimagearray.compliant = "1";
            tempuploadedimagearray.processed = "1";
            tempuploadedimagearray.editpermission = 0;
            tempuploadedimagearray.spacetype = "front_view";
            removeulphotobreak("Non-Compliant_front_view",imageidentity);
            addtoulphotobreak("front_view",imageidentity);
        }
        setuploadedimages([...tempuploadedimages]);
        var compliancefailed = tempuploadedimages.filter(x=>x.compliant == "0");
        setcompliancepassed(!(compliancefailed.length > 0));
    }
    else{
        var liitem = [...document.querySelectorAll(".photobreak li")].filter(a => a.innerText.includes("front_view"));
        if (parseInt(editpermission) == 3 && (liitem && liitem.length <= 0)) {
            customAlertMessage('error','Atleast single front view is required to ignore compliance.');
            return;
        }
        var tempuploadedimages = uploadedimages;
        var tempuploadedimagearray = tempuploadedimages.find(x=>x.image == imageidentity);
        if (tempuploadedimagearray != undefined) {        
            tempuploadedimagearray.compliant = "1";
            tempuploadedimagearray.processed = parseInt(editpermission) == 2 ? "1": "0";
            tempuploadedimagearray.editpermission = 0;
        }
        setuploadedimages([...tempuploadedimages]);
        if (parseInt(editpermission) != 2) {
            processroomtypes_s_i(processid,imageidentity);    
        }    
        else if(parseInt(editpermission) == 2){
            addtoulphotobreak(spacetype,imageidentity);
        }
    }
    
  }

  const removefromprocessedlist = (e)=>{
    var referenceid = e.currentTarget.dataset.filerefid;
    var spacetype = e.currentTarget.dataset.spacetype;
    var filteredprocessimage = uploadedimages.filter(function (entry) { return entry.image !== referenceid; });
    setuploadedimages([...filteredprocessimage]);    
    // un comment to make image compliance mandatory
    var compliancefailed = filteredprocessimage.filter(x=>x.compliant == "0");
    setcompliancepassed(!(compliancefailed.length > 0));
    
    //Remove from first step
    var filteredprocessimage = processedimage.filter(function (entry) { return entry.refid !== (referenceid.replace(".jpeg","")); });
    setprocessedimage([...filteredprocessimage]);
    var filtereduploadedfile = uploadedfile.filter(function (entry) { return entry.identity !== (referenceid.replace(".jpeg","")); });
    setuploadedfile([...filtereduploadedfile]);
    var  filterorderedprocessedimage = orderedprocessedimage.filter(function (entry) { return entry.refid !== (referenceid.replace(".jpeg","")); });
    setorderedprocessedimage([...filterorderedprocessedimage]);

    if (e.currentTarget.parentElement.classList.contains('validcomp')) {
        removeulphotobreak(spacetype,referenceid);
    }
    removefilefromserver(referenceid);
    
  }
  const removefromlist = (e) => {
    var referenceid = e.currentTarget.dataset.filerefid;
    var filteredprocessimage = processedimage.filter(function (entry) { return entry.refid !== referenceid; });
    setprocessedimage([...filteredprocessimage]);
    var filtereduploadedfile = uploadedfile.filter(function (entry) { return entry.identity !== referenceid; });
    setuploadedfile([...filtereduploadedfile]);
    var  filterorderedprocessedimage = orderedprocessedimage.filter(function (entry) { return entry.refid !== referenceid; });
    setorderedprocessedimage([...filterorderedprocessedimage]);

    if (uploadedimages.length > 0) {
        var filteredprocessimage = uploadedimages.filter(function (entry) { return entry.image !== (referenceid+".jpeg"); });
        setuploadedimages([...filteredprocessimage]);   

        var compliancefailed = filteredprocessimage.filter(x=>x.compliant == "0");  
        setcompliancepassed(!(compliancefailed.length > 0));
        removefilefromserver(referenceid);
    }
    
}

const removefilefromserver=(imagename)=>{
    // showoverlaytwo();
    const axios = require('axios');
    const FormData = require('form-data');
    let data = new FormData();
    data.append('uid', UserID);
    data.append('companyid', Companyid);
    data.append('processid', processid);
    data.append('name', imagename);        
        let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}` +'/api/ArtificialIntelligence/removeimage',
        // url: 'https://localhost:44372/api/ArtificialIntelligence/removeimage',
        data : data
        };

        axios.request(config)
        .then((response) => {
            // console.log(JSON.stringify(response.data));
            var Responsedata = response.data.Message;
            if (Responsedata != "" && Responsedata != null && Responsedata=="success") {
                // hideoverlaytwo();
            }
            else{
                // customAlertMessage('error','Something went wrong, Please try again.');
                // hideoverlaytwo();
            }
            
        })
        .catch((error) => {
            console.log(error);
            customAlertMessage('error','Something went wrong, Please try again.');
            // hideoverlaytwo();
        });
}

const startprocess_single=()=> {
    if (uploadedimages.length <= 0) {
        return;
    }
    var filteredarray = [...document.querySelectorAll('.mlsright li')].filter(el => el.dataset.processed == "-1");
    var filteredarrayfailed = [...document.querySelectorAll('.mlsright li')].filter(el => el.dataset.processed == "-10");
    if(filteredarray.length > 0)
    {
        var originalidentity = filteredarray[0].dataset.actualidentity;
        processcompliance_s_i(processid,originalidentity);
        setanalyzingroomtype(true);
        var tempuploadedimages = uploadedimages;
        var tempuploadedimagearray = tempuploadedimages.find(x=>x.image == originalidentity);
        if (tempuploadedimagearray != undefined) {
            tempuploadedimagearray.processed = "0";
        }
        setuploadedimages([...tempuploadedimages]);
    }
    else if(filteredarrayfailed.length > 0)
    {
        var originalidentity = filteredarrayfailed[0].dataset.actualidentity;
        processcompliance_s_i(processid,originalidentity);
        setanalyzingroomtype(true);
        var tempuploadedimages = uploadedimages;
        var tempuploadedimagearray = tempuploadedimages.find(x=>x.image == originalidentity);
        if (tempuploadedimagearray != undefined) {
            tempuploadedimagearray.processed = "0";
        }
        setuploadedimages([...tempuploadedimages]);
    }
    else{            
        var processedimages = uploadedimages.filter(x=>x.processed == "1");
        if (processedimages.length == uploadedimages.length) {
            var compliancefailed = uploadedimages.filter(x=>x.compliant == "0");
            setcompliancepassed(!(compliancefailed.length > 0));
            document.getElementById('complianceproceed').style.display = 'inline-block';
            setanalyzingroomtype(false);
        }        
    }
}

const startprocess=()=>{
    if (uploadedimages.length <= 0) {
        return;
    }
    var filteredarray = [...document.querySelectorAll('.mlsright li')].filter(el => el.dataset.processed == "-1");
    if(filteredarray.length > 0)
    {
        const slicedArray = filteredarray.slice(0, 10);
        slicedArray.forEach(element => {
            var originalidentity = element.dataset.actualidentity;
            processcompliance_s_i(processid,originalidentity);
            setanalyzingroomtype(true);
            var tempuploadedimages = uploadedimages;
            var tempuploadedimagearray = tempuploadedimages.find(x=>x.image == originalidentity);
            if (tempuploadedimagearray != undefined) {
                tempuploadedimagearray.processed = "0";
            }
            setuploadedimages([...tempuploadedimages]);
        });
    }
    else{            
        var processedimages = uploadedimages.filter(x=>x.processed == "1");
        if (processedimages.length == uploadedimages.length) {
            // un comment to make image compliance mandatory
            var compliancefailed = uploadedimages.filter(x=>x.compliant == "0");
            setcompliancepassed(!(compliancefailed.length > 0));
            document.getElementById('complianceproceed').style.display = 'inline-block';
            setanalyzingroomtype(false);
        }
        
    }
    return;
    var lilist = document.querySelectorAll('.mlsright li');
    var itemstoprocess = 0;
    lilist.filter(el=> el.dataset.processed == "-1")
    lilist.forEach(element => {
        var processed = element.dataset.processed;
        var originalidentity = element.dataset.actualidentity;
        if (processed === "-1") {
            processcompliance_s_i(processid,originalidentity);
            // processroomtypes_s_i(processid,originalidentity);
            var tempuploadedimages = uploadedimages;
            var tempuploadedimagearray = tempuploadedimages.find(x=>x.image == originalidentity);
            if (tempuploadedimagearray != undefined) {
                tempuploadedimagearray.processed = "0";
            }
            //check array updating automatically
            setuploadedimages([...tempuploadedimages]);
            // element.dataset.actualidentity = "0";
            itemstoprocess += 1;
        }
        else{            
            var processedimages = uploadedimages.filter(x=>x.processed == "1");
            if (processedimages.length == uploadedimages.length) {
                var compliancefailed = uploadedimages.filter(x=>x.compliant == "0");
                setcompliancepassed(!(compliancefailed.length > 0));
                setanalyzingroomtype(false);
            }
            
        }
    });
}

function validatePropertyDetails (){
    var propTypeSel = document.getElementById("ddlPropertyType").value;
    if (propTypeSel != "select") {
        customAlertMessage('error', 'Please select property type.');
        return false;
    }
    var ddlBedrooms = document.getElementById("ddlBedrooms").value;
    if(ddlBedrooms == "select"){
        customAlertMessage('error', 'Number of bedrooms is required.');
        return false;
    }
    var ddlBathrooms = document.getElementById("ddlBathrooms").value;
    if(ddlBathrooms == "select"){
        customAlertMessage('error', 'Number of bathrooms is required.');
        return false;
    }
    var ddlFloors = document.getElementById("ddlFloors").value;
    if(ddlFloors == "select"){
        customAlertMessage('error', 'Number of floors is required.');
        return false;
    }
    var txtArea = document.getElementById("txtArea").value;
    if(txtArea == ""){
        customAlertMessage('error', 'Floor area is required.');
        return false;
    }
}


function loadAmenities(placelat,placeng){    
    //sleep(3);
    var serviceData = new window.google.maps.places.PlacesService(document.createElement('div1Result'));
    var pyrmont = new window.google.maps.LatLng(placelat,placeng);
    const request = {
        location: pyrmont,
        fields: ["name"],
        radius: '8033',
        rankby:'distance',
        type: ['school']
      };
      serviceData.nearbySearch(request, callbackSchool);
    //   >hospital
    //   >park
    //   >supermarket
    const requesthospitals = {
        location: pyrmont,
        fields: ["name"],
        radius: '8033',
        rankby:'distance',
        type: ['hospital']
      };
      serviceData.nearbySearch(requesthospitals, callbackHospitals);

      const requestpark = {
        location: pyrmont,
        fields: ["name"],
        radius: '8033',
        rankby:'distance',
        type: ['park']
      };
      serviceData.nearbySearch(requestpark, callbackParks);

      const requestsupermarket = {
        location: pyrmont,
        fields: ["name"],
        radius: '8033',
        rankby:'distance',
        type: ['supermarket']
      };
      serviceData.nearbySearch(requestsupermarket, callbackSupermarkets);

      document.getElementById("div1Result").style.display="block";      
}

function callbackSchool(results, status){
    if (status == window.google.maps.places.PlacesServiceStatus.OK) {
        var divSchoolsData = document.getElementById('divSchoolsData');
        divSchoolsData.style.display="block";
        if (results !=undefined && results.length > 0) {            
            var schoolsText="<ul class='checkbox-category'>";
            for (var i = 0; i < results.length; i++) {
                // create list of schools
                //console.log('schools data '+i + " " + results[i].name);                
                schoolsText +=  "<li><input class='chkSchoolAmenities' id='chkschoolAmenity"+i+"' name='schoolAmenity' type='checkbox' />&nbsp;<label id='lblschoolAmenity"+i+"'>"+results[i].name+"</label></li>";     
                if(i==9){
                    break;
                }           
            }
            schoolsText = schoolsText + "</ul>";   
            divSchoolsData.innerHTML =schoolsText;
        }
        else{
            divSchoolsData.innerText ="No data found.";
        }      
    }
    else{
        document.getElementById('divSchoolsData').innerText ="No data found.";
    }
    hideoverlay();
  }

  function callbackHospitals(results, status){
    if (status == window.google.maps.places.PlacesServiceStatus.OK) {
        var divSchoolsData = document.getElementById('divHospitalsData');
        divSchoolsData.style.display="block";
        if (results !=undefined && results.length > 0) {            
            var schoolsText="<ul class='checkbox-category'>";
            for (var i = 0; i < results.length; i++) {
                // create list of schools
                //console.log('schools data '+i + " " + results[i].name);                
                schoolsText +=  "<li><input class='chkHospitalAmenities' id='chkhospitalAmenity"+i+"' name='hospitalAmenity' type='checkbox' />&nbsp;<label id='lblhospitalAmenity"+i+"'>"+results[i].name+"</label></li>";     
                if(i==9){
                    break;
                }           
            }
            schoolsText = schoolsText + "</ul>";   
            divSchoolsData.innerHTML =schoolsText;
        }
        else{
            divSchoolsData.innerHTML = "<p>No data found.</p>";
        }
    }
    else{
        document.getElementById('divHospitalsData').innerText ="No data found.";
    }
    hideoverlay();
  }

  function callbackParks(results, status){
    if (status == window.google.maps.places.PlacesServiceStatus.OK) {
        var divSchoolsData = document.getElementById('divParksData');
        divSchoolsData.style.display="block";
        if (results !=undefined && results.length > 0) {            
            var schoolsText="<ul class='checkbox-category'>";
            for (var i = 0; i < results.length; i++) {
                // create list of schools
                //console.log('schools data '+i + " " + results[i].name);                
                schoolsText +=  "<li><input class='chkParkAmenities' id='chkparkAmenity"+i+"' name='parkAmenity' type='checkbox' />&nbsp;<label id='lblparkAmenity"+i+"'>"+results[i].name+"</label></li>";     
                if(i==9){
                    break;
                }           
            }
            schoolsText = schoolsText + "</ul>";   
            divSchoolsData.innerHTML =schoolsText;
        }
        else{
            divSchoolsData.innerText ="No data found.";
        }
    }
    else{
        document.getElementById('divParksData').innerText ="No data found.";
    }
    hideoverlay();
  }

  function callbackSupermarkets(results, status){
    if (status == window.google.maps.places.PlacesServiceStatus.OK) {
        var divSchoolsData = document.getElementById('divSsupermarketsData');
        divSchoolsData.style.display="block";
        if (results !=undefined && results.length > 0) {            
            var schoolsText="<ul class='checkbox-category'>";
            for (var i = 0; i < results.length; i++) {
                // create list of schools
                //console.log('schools data '+i + " " + results[i].name);                
                schoolsText +=  "<li><input class='chkSupermarketAmenities' id='chksupermarketAmenity"+i+"' name='supermarketAmenity' type='checkbox' />&nbsp;<label id='lblsupermarketAmenity"+i+"'>"+results[i].name+"</label></li>";     
                if(i==9){
                    break;
                }           
            }
            schoolsText = schoolsText + "</ul>";   
            divSchoolsData.innerHTML =schoolsText;
        }
        else{
            divSchoolsData.innerText ="No data found.";
        }
    }
    else{
        document.getElementById('divSsupermarketsData').innerText ="No data found.";
    }
    hideoverlay();
  }

  function countUniqueStrings(csv) {
    // Split the string by commas, trim whitespace, and filter out empty strings
    const items = csv.split(',')
                     .map(item => item.trim())
                     .filter(item => item.length > 0);
  
    // Use a Set to store unique items
    const uniqueItems = new Set(items);
  
    // Return the count of unique items
    return uniqueItems.size;
  }
  const addtoulphotobreak=(name,identity)=>{
    try {
        var liitem = [...document.querySelectorAll(".photobreak li")].filter(a => a.innerText.includes(name));
        if (liitem && liitem.length > 0) {
            // var count = parseInt(liitem[0].getElementsByTagName('span')[1].innerText);
            if (liitem[0].getElementsByTagName('span')[1].dataset.identities.indexOf(identity) == -1) {
                var commaseparated = liitem[0].getElementsByTagName('span')[1].dataset.identities + identity+",";
                liitem[0].getElementsByTagName('span')[1].dataset.identities = commaseparated;
                liitem[0].getElementsByTagName('span')[1].innerText = countUniqueStrings(commaseparated);;
            }            
        }
        else{
            var li = document.createElement('li');
            var span = document.createElement('span');
            span.innerText = name;
            li.appendChild(span);
            var cntspan = document.createElement('span');
            cntspan.innerText = "1";
            cntspan.dataset.identities = identity+",";
            li.appendChild(cntspan);
            document.getElementsByClassName('photobreak')[0].appendChild(li);
            lirearrange();
        }    
    } catch (error) {
        
    }
    
  }

  const lirearrange =()=>{
    const list = document.querySelector('.photobreak');

// Convert the NodeList of <li> elements to an array
const itemsArray = Array.from(list.querySelectorAll('li'));

// Sort the array
itemsArray.sort((a, b) => a.textContent.localeCompare(b.textContent));

// Append each sorted <li> back to the parent element
itemsArray.forEach(li => list.appendChild(li));
  }

  const removeulphotobreak=(name,identity)=>{
    try {
        var liitem = [...document.querySelectorAll(".photobreak li")].filter(a => a.innerText.includes(name));
        if (liitem && liitem.length > 0) {
            // var count = parseInt(liitem[0].getElementsByTagName('span')[1].innerText);
            if (liitem[0].getElementsByTagName('span')[1].dataset.identities.indexOf(identity) != -1) {
                var commaseparated = liitem[0].getElementsByTagName('span')[1].dataset.identities.replace(identity,"");
                liitem[0].getElementsByTagName('span')[1].dataset.identities = commaseparated;
                var countstrings = countUniqueStrings(commaseparated);
                if (countstrings == 0) {
                    liitem[0].remove();
                    lirearrange();
                }
                else{
                    liitem[0].getElementsByTagName('span')[1].innerText = countstrings;
                }                
            }            
        }
        // else{
        //     var li = document.createElement('li');
        //     var span = document.createElement('span');
        //     span.innerText = name;
        //     li.appendChild(span);
        //     var cntspan = document.createElement('span');
        //     cntspan.innerText = "1";
        //     cntspan.dataset.identities = identity+",";
        //     li.appendChild(cntspan);
        //     document.getElementsByClassName('photobreak')[0].appendChild(li);
        // }    
    } catch (error) {
        
    }
    
  }
  const resettoinitialwithajaxcheck =()=>{
    var filteredarray = [...document.querySelectorAll('.mlsright li')].filter(el => (el.dataset.processed == "0" || el.dataset.processed == "-1"));
    if (filteredarray.length > 0) {
        customAlertMessage("error", "Please wait while we are processing the images.");
        return;
    }
    document.getElementById('upload_div').style.display ="block";
    document.getElementById('main_div').style.display = "none";
    resettoinitial();
  }
  //comehere
  const Addmoreimage=()=>{
    document.getElementById('upload_div').style.display ="block";
    document.getElementById('main_div').style.display = "none";
    document.getElementById('showstartbtn').style.display = "none";
    document.getElementsByClassName('dropzone')[0].click();
  }

  const removerequiredfield =(e)=>{
    var vallll = e.currentTarget.value;
    var element = e.currentTarget;
    // var tempdropdownvalues = dropdownvalues;
    if (vallll != "-1") {
        element.classList.remove("requirederror");
    }
    else {
        element.classList.add("requirederror");
    }
    var identity = e.currentTarget.dataset.filerefid;
    var selectedspacetype = e.currentTarget.dataset.selectedspacetype;
    var tempuploadedimages = uploadedimages;
    var tempuploadedimagearray = tempuploadedimages.find(x=>x.image == identity);
    if (tempuploadedimagearray != undefined) {
        var existingspacetype = tempuploadedimagearray.spacetype;
        removeulphotobreak(existingspacetype,identity);
        if (tempuploadedimagearray.spacetype != vallll) {
            tempuploadedimagearray.spacetype = vallll;
            // var liitem = [...document.querySelectorAll(".photobreak li")].filter(a => a.innerText.includes(name));
            // if (liitem && liitem.length > 0) {
            addtoulphotobreak(vallll,identity);
        }
        setuploadedimages([...tempuploadedimages]);
    }
  }

  const showcopyrightreference=(e)=>{
    try {
        var divResult = document.getElementById('divResult');
        divResult.innerHTML = "";
        var identity  = e.currentTarget.dataset.filerefid;
        var declutterelement = uploadedimages.find(x=>x.image === identity);
        var referenceimages = JSON.parse(declutterelement.description);
        var counter = 1;
        var htmlRes = "";        
        referenceimages.forEach(function (arrayItem) {
            var fullmatchimages = arrayItem.fullMatchingImages;
            var partialmatchimages = arrayItem.partialMatchingImages;
            var imgUrl = "";
            var mlsnumber = "";
            if (fullmatchimages != null) {
                imgUrl = fullmatchimages[0].url;
                mlsnumber = "Full";
            }
            if (partialmatchimages != null) {
                imgUrl = partialmatchimages[0].url;
                mlsnumber = "Partial";
            }
            var targeturl = arrayItem.url
            var Title = arrayItem.pageTitle != null ? arrayItem.pageTitle : "";

            htmlRes += "<div class='row'><div class='col-12'><p>Result: " + counter + "</p></div>"+
            "<div class='col-6'><img src='"+imgUrl +"' />"+
            "</div><div class='col-6'>" +
                "<p><b>Page title:</b> " + Title + "</p>" +
                "<p><b>Match found:</b> <a href='"+targeturl +"' target='_blank'>" + targeturl + "</a></p>" +
                "<p><b>Match Type:</b> " + mlsnumber + "</p>" +
            "</div><div class='col-12'><hr class='bordermfline'></hr></div></div>";
            counter++;
        });
        divResult.innerHTML += htmlRes;
        document.getElementById('hrefcopyrightmodal').click();
    } catch (error) {
        console.log(error);
    }
  }
    // const removerequiredfield = (e) => {
    //     var vallll = e.currentTarget.value;
    //     var element = e.currentTarget;
    //     var tempdropdownvalues = dropdownvalues;
    //     if (vallll != "-1") {
    //         element.classList.remove("requirederror");
    //     }
    //     else {
    //         element.classList.add("requirederror");
    //     }
    //     var refid = element.dataset.filerefid;
    //     var selectedoption = tempdropdownvalues.filter(function (entry) { return entry.refid == refid; });
    //     if (selectedoption.length > 0) {
    //         selectedoption[0].text = vallll;
    //     }
    //     else {
    //         var sitem = {};
    //         sitem.refid = refid;
    //         sitem.text = vallll;
    //         tempdropdownvalues.push(sitem);
    //     }
    //     setdropdownvalues(tempdropdownvalues);
    // }

    // render(){
        //htmlhere
    return (
        <>        
        
        <div className="main_content_iner overly_inner dashboard-page">
            <div className="container-fluid p-0 " id="mlscompliancediv">
                <div className="row">
                    <div className="col-12">
                        <div className="title-card1">
                            <h4>
                                <span
                                    style={{ cursor: "pointer" }}
                                    onClick={historygoback}
                                >
                                    <FontAwesomeIcon icon={faChevronLeft} />
                                    MLS
                                </span>
                            </h4>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="stepper-count-wrap">
                            <div className="pd-stepper-count">
                                <div className="step-count-div">
                                    <div className="step-wrap">
                                        <div id="div1" className="step-count" onClick={showstep1}>
                                            <span id="countno1">1</span>
                                            <FontAwesomeIcon icon={faCheck} id="checkmarkvalid1" style={{display:"none"}}/>
                                        </div>
                                    </div>
                                    <div className="step-title">Upload Image</div>
                                </div>
                                <div className="step-count-div">
                                    <div className="step-wrap">
                                        <div id="div2" className="step-count inactive" onClick={showstep2}>
                                        <span id="countno2">2</span>
                                            <FontAwesomeIcon icon={faCheck} id="checkmarkvalid2" style={{display:"none"}}/>
                                        </div>
                                    </div>
                                    <div className="step-title">Photo Compliance and Features</div>
                                </div>
                                <div className="step-count-div">
                                    <div className="step-wrap">
                                        <div id="div3" className="step-count inactive" onClick={showstep3}>
                                        <span id="countno3">3</span>
                                            <FontAwesomeIcon icon={faCheck} id="checkmarkvalid3" style={{display:"none"}}/>
                                        </div>
                                    </div>
                                    <div className="step-title">Property Details</div>
                                </div>
                                <div className="step-count-div" >
                                    <div className="step-wrap">
                                        <div id="div4" className="step-count inactive" onClick={showstep4}>
                                        <span id="countno4">4</span>
                                            <FontAwesomeIcon icon={faCheck} id="checkmarkvalid4" style={{display:"none"}}/>
                                        </div>
                                    </div>
                                    <div className="step-title">Generate Listing Description</div>
                                </div>
                                <div className="stepper-bar"><div className="step-bar"></div></div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="row" id="showstartbtn" style={{display:'none'}}>
                    <div className="col-12 float-end">
                        <a href="javascript:;" className="newstart-btn common-save float-end" onClick={resettoinitialwithajaxcheck}>Start New</a>
                    </div>
                </div> */}
                <div className="row" id="newloaderprop" style={{display:"none"}}>
                    <div className="col-12">
                        <div className="rotating-text-wrapper-new">
                            <center></center><img src={loader} className="loadernewprop"/>
                            <div className="rotating-text-wrapper">                                                
                                {/* <h2>Checking images for branding.</h2>
                                <h2>Checking images for sign posts.</h2>
                                <h2>Checking images for watermarks.</h2>
                                <h2>Checking images for agent info...</h2>
                                <h2>Checking images for people...</h2>
                                <h2>Checking images for custom MLS rules...</h2> */}
                                <h2>Hold tight, chocolatechips.ai is writing the description for you!</h2>
                                <h2>Adding a powerful headline....</h2>
                                <h2>Almost done....</h2>
                            </div>
                        </div>
                    </div>
                </div>                
                <div className="row" id="upload_div">
                    <div className="col-12" style={{marginBottom:"20px"}}>
                        {/* <div className="row"> */}                   
                        <div className="row">
                            <div className="col-12" id="divpropertyaddress">
                                <div className="row">
                                    <div className="col-5" style={{position:"relative"}}>
                                        <label>
                                            Property address
                                        </label>
                                        {/* <input type="text" className="common-input"></input> */}
                                        {/* <SearchLocationInput onChange={() => null} /> */}
                                        <div className="search-location-input">
                                            <input id="txtPropAddress"
                                                ref={autoCompleteRef} className="common-input"
                                                onChange={event => setQuery(event.target.value)}
                                                placeholder="Enter your address"
                                                value={query}
                                            />
                                            <FontAwesomeIcon className="clearProp" onClick={()=> clearPropAddress()} icon={faXmark} />
                                            <input id="hfLocationId" value={locationId} type="hidden"></input>
                                        </div>
                                    </div>                                        
                                </div>
                            </div>
                        </div>
                            {/* <div className="col-12" id="divpropertyaddress">
                                <div className="row">
                                    <div className="col-9" style={{ position: "relative" }}>                                        
                                        <label>
                                            Property address
                                        </label>
                                        <div className="search-location-input">
                                            <input id="txtPropAddress"
                                                ref={autoCompleteRef} className="common-input"
                                                onChange={event => setQuery(event.target.value)}
                                                placeholder="Enter your address"
                                                value={query}
                                            />
                                            <FontAwesomeIcon className="clearProp" onClick={() => clearPropAddress()} icon={faXmark} />
                                            <input id="hfLocationId" value={locationId} type="hidden"></input>
                                        </div>
                                    </div>
                                </div>
                            </div> */}



                        {/* </div> */}
                    </div>
                    <div className="col-12">
                        <div className="dropzone-wrapper mobiletop0" style={{ width: "100%", marginBottom: "40px", marginTop: "15px", height:"230px" }} onDragEnter={dropzonedragenter} onDragOver={dropzonedragover} onDragLeave={dropzonedragleave} onDrop={dropzonefiledrop} >
                            <div id="overlayiphone">
                                <div id="loading" style={{ top: "35%" }}>                                    
                                    <img src={loader} />
                                    <h2 id="loaderheading" className="loaderheading"><span>Processing...</span></h2>
                                </div>
                            </div>
                            <div className="dropzone-desc">
                                <h4>Drag and Drop</h4>
                                <p><b>or Click to upload</b></p>
                                <FontAwesomeIcon icon={faCloudArrowUp} />
                                <p>
                                    Supported Files: PNG, JPG, HEIF, HEIC.
                                </p>
                                {processedimage && processedimage.length > 0 ?
                                <p>
                                    {processedimage.length} images selected.
                                </p>
                                : null}
                            </div>
                            <input type="file" name="img_logo" className="dropzone" title='' onChange={dropzonechange} accept="image/png, image/jpeg, image/jpg, image/heif, image/heic" multiple={true}></input>
                        </div>
                    </div>
                    <div className="col-12">
                    <ul className="mlsuploadedphoto">
                        {processedimage && processedimage.length > 0 ? processedimage.map((d) => ( 
                            <li key={uuidv4()}>
                                <img src={d.image} />
                                <span className="removeuploaded" data-filerefid={d.refid} onClick={removefromlist}>
                                    <FontAwesomeIcon icon={faRemove}/>
                                </span>
                            </li>
                        ))
                        
                    : null}
                            
                        </ul>
                    </div>                 
                    {processedimage && processedimage.length > 0 ?
                        <div className="col-12">
                            <center>
                                <a href="javascript:;" className="common-save" style={{ marginTop: "20px", marginBottom:"30px" }} onClick={uploadimages}>Continue</a>
                                <a href="javascript:;" className="common-clear" style={{marginTop: "20px", marginBottom:"30px"}} onClick={resettoinitial}>Reset</a>
                            </center>
                        </div> : null}
                </div>
                <div className="row" id="main_div" style={{display:'none'}}>
                {/* <div className="row" id="main_div"> */}
                    <div className="col-12" style={{ position: 'relative' }}>
                        <div id="overlayloader4" className="email-overlay" style={{ display: "none" }}>
                            <div id="loading">
                                <img src={loader} />
                                <h2 id="loaderheading" className="loaderheading"><span>Processing...</span></h2>
                            </div>
                        </div>
                        <div id="overlaytwomls">
                            <div id="loading" style={{ top: "30%" }}>
                                <img src={loader} />
                                <h2 id="loaderheading" className="loaderheading"><span>Processing...</span></h2>
                            </div>
                        </div>
                        <div id="overlay">
                            <div id="loading" style={{ top: "30%" }}>
                                <img src={loader} />
                                <h2 id="loaderheading" className="loaderheading"><span>Analyzing room types...</span></h2>
                            </div>
                        </div>
                    </div>
                    <div className="col-2 mlsleftside">
                        <label>
                            <h4>Total Images</h4>
                            {uploadedimages.length > 0 ?
                                <p>Done! ({uploadedimages.length} images)<FontAwesomeIcon icon={faCheck} className="mlscheck" /></p>
                                :
                                <p className="loadingellipsis">Processing</p>
                            }
                        </label>
                        <label>
                            <h4>Space Classification</h4>
                            {uploadedimages.length > 0 && analyzingroomtype != null && analyzingroomtype == false ?
                                <p>Done! ({uploadedimages.length} images)<FontAwesomeIcon icon={faCheck} className="mlscheck" /></p>
                                : (uploadedimages.length > 0 ? <p className="loadingellipsis">Analyzing</p> : null )
                                
                            }

                        </label>
                        {/* <label>
                            <h4>Features Detection</h4>
                            <p>Ok! (50 images)<FontAwesomeIcon icon={faCheck} className="mlscheck" /></p>
                        </label> */}
                        <label>
                            <h4>Image Descriptions</h4>
                            {uploadedimages.length > 0 && analyzingroomtype != null && analyzingroomtype == false ?
                                <p>Done! ({uploadedimages.length} images)<FontAwesomeIcon icon={faCheck} className="mlscheck" /></p>
                                : (uploadedimages.length > 0 ? <p className="loadingellipsis">Analyzing</p> : null )
                            }
                        </label>
                        <label>
                            <h4>Compliance</h4>
                            {compliancepassed == true ?
                                <p>Passed!<FontAwesomeIcon icon={faCheck} className="mlscheck" /></p>
                                : (compliancepassed == false ?
                                    <p>Failed <FontAwesomeIcon icon={faClose} className="mlscheck" style={{ color: 'red' }} /></p> : null)
                            }
                            {/* <p>Ok!<FontAwesomeIcon icon={faCheck} className="mlscheck" /></p> */}
                        </label>
                        <label>
                            <h4>Listing Descriptions</h4>
                            {listingdescriptionstatus == 1 ?
                                <p>Ok!<FontAwesomeIcon icon={faCheck} className="mlscheck" /></p>
                                : (listingdescriptionstatus == 2 ?
                                    <p>Failed <FontAwesomeIcon icon={faClose} className="mlscheck" style={{ color: 'red' }} /></p> : null)
                            }
                            {/* <p>Ok!<FontAwesomeIcon icon={faCheck} className="mlscheck" /></p> */}
                        </label>
                        <div id="showstartbtn" style={{display:'none'}}>
                            <a href="javascript:;" className="newstart-btn common-save" onClick={resettoinitialwithajaxcheck}>Start New</a>
                        </div>
                        
                    </div>
                    <div className="col-10" id="imagesdiv">
                        <div className="row">
                            <div className="col-8">
                                <ul className="mlsright" style={{display:(uploadedimages.length > 0 ? 'block':'none')}}>
                                    {uploadedimages.length > 0 ? uploadedimages.map((d) => (
                                        <li id={d.image.split('.').join('_')} data-processed={d.processed} data-actualidentity={d.image} className={d.compliant == "0"? "errorcomplaince":"validcomp"}>
                                            <img src={(d.processed == "1" && d.compliant == "0" && d.compliancefailedimage != "" ? (d.compliancefailedimage) : (localimagebasepath + processid + "/" + d.image))} />
                                            <div className="validcompliance" style={{display:(d.processed == "1" && d.compliant != "0" ? 'block' :'none')}}>
                                                {/* <h4 contentEditable="true">{d.spacetype}</h4>
                                                <p contentEditable="true">{d.description}</p> */}
                                                <center>
                                                    <select className="commonselectNew imageoption" onChange={removerequiredfield} data-filerefid={d.image} data-selectedspacetype={d.spacetype}>
                                                        <option value="-1">Select space type*</option>
                                                        <option value="aerial_view" selected={(d.spacetype == "aerial_view" ? true: false)}>Aerial view</option>
                                                        <option value="apartment_facade" selected={(d.spacetype == "apartment_facade" ? true: false)}>Apartment facade</option>
                                                        <option value="backyard" selected={(d.spacetype == "backyard" ? true: false)}>Backyard</option>
                                                        <option value="balcony" selected={(d.spacetype == "balcony" ? true: false)}>Balcony</option>
                                                        <option value="bar" selected={(d.spacetype == "bar" ? true: false)}>Bar</option>
                                                        <option value="barbecue" selected={(d.spacetype == "barbecue" ? true: false)}>Barbecue</option>
                                                        <option value="bathroom" selected={(d.spacetype == "bathroom" ? true: false)}>Bathroom</option>
                                                        <option value="bedroom" selected={(d.spacetype == "bedroom" ? true: false)}>Bedroom</option>
                                                        <option value="courtyard" selected={(d.spacetype == "courtyard" ? true: false)}>Courtyard</option>
                                                        <option value="dining_room" selected={(d.spacetype == "dining_room" ? true: false)}>Dining</option>
                                                        {/* <option value="empty_space" selected={(d.spacetype == "empty_space" ? true: false)}>Empty space</option> */}
                                                        <option value="foyer" selected={(d.spacetype == "foyer" ? true: false)}>Foyer</option>
                                                        <option value="front_view" selected={(d.spacetype == "front_view" ? true: false)}>Front view</option>
                                                        <option value="game_room" selected={(d.spacetype == "game_room" ? true: false)}>Game room</option>
                                                        <option value="garage" selected={(d.spacetype == "garage" ? true: false)}>Garage</option>
                                                        <option value="Garden_or_Landscaping" selected={(d.spacetype == "Garden_or_Landscaping" ? true: false)}>Garden/Landscaping</option>
                                                        <option value="gym" selected={(d.spacetype == "gym" ? true: false)}>Gym</option>
                                                        <option value="hallway" selected={(d.spacetype == "hallway" ? true: false)}>Hallway</option>
                                                        <option value="hobby_room" selected={(d.spacetype == "hobby_room" ? true: false)}>Hobby room</option>
                                                        <option value="jacuzzi" selected={(d.spacetype == "jacuzzi" ? true: false)}>Jacuzzi</option>
                                                        <option value="kids_room" selected={(d.spacetype == "kids_room" ? true: false)}>Kids room</option>
                                                        <option value="kitchen" selected={(d.spacetype == "kitchen" ? true: false)}>Kitchen</option>
                                                        <option value="Kitchen_dining" selected={(d.spacetype == "Kitchen_dining" ? true: false)}>Kitchen dining</option>
                                                        <option value="laundry_area" selected={(d.spacetype == "laundry_area" ? true: false)}>Laundry area</option>
                                                        <option value="living_room" selected={(d.spacetype == "living_room" ? true: false)}>Living room</option>
                                                        <option value="media_room" selected={(d.spacetype == "media_room" ? true: false)}>Media room</option>
                                                        <option value="Non-Compliant_front_view" selected={(d.spacetype == "Non-Compliant_front_view" ? true: false)}>Non-Compliant front view</option>
                                                        <option value="nursery" selected={(d.spacetype == "nursery" ? true: false)}>Nursery</option>
                                                        <option value="home_office" selected={(d.spacetype == "home_office" ? true: false)}>Office</option>
                                                        <option value="outdoor_living" selected={(d.spacetype == "outdoor_living" ? true: false)}>Outdoor living</option>
                                                        <option value="pantry" selected={(d.spacetype == "pantry" ? true: false)}>Pantry</option>
                                                        <option value="patio" selected={(d.spacetype == "patio" ? true: false)}>Patio</option>
                                                        <option value="playground" selected={(d.spacetype == "playground" ? true: false)}>Playground</option>
                                                        <option value="swimming_pool_or_poolside" selected={(d.spacetype == "swimming_pool_or_poolside" ? true: false)}>Poolside</option>
                                                        <option value="shower" selected={(d.spacetype == "shower" ? true: false)}>Shower</option>                                                        
                                                        <option value="staircase" selected={(d.spacetype == "staircase" ? true: false)}>Staircase</option>
                                                        <option value="study_room" selected={(d.spacetype == "study_room" ? true: false)}>Study room</option>
                                                        <option value="sunroom" selected={(d.spacetype == "sunroom" ? true: false)}>Sunroom</option>                                                        
                                                        <option value="view" selected={(d.spacetype == "view" ? true: false)}>View</option>
                                                        <option value="walk-in_closet" selected={(d.spacetype == "walk-in_closet" ? true: false)}>Walk-in Closet</option>
                                                        <option value="wardrobe" selected={(d.spacetype == "wardrobe" ? true: false)}>Wardrobe</option>
                                                        <option value="waterfront" selected={(d.spacetype == "waterfront" ? true: false)}>Waterfront</option>
                                                    </select>
                                                </center>
                                                   <h4 style={{display:'none'}}>{d.spacetype}</h4>
                                                <p contentEditable="true">{d.description}</p>
                                                 {/* <h4>&nbsp;</h4>
                                                <p>&nbsp;</p> */}
                                            </div>
                                            <div className="invalidcompliance" style={{display:(d.processed == "1" && d.compliant == "0" ? 'block' :'none')}}>
                                                {/* <h4 style={{display:(parseInt(d.editpermission) == 1 ? 'none': 'block')}}>{d.spacetype}</h4>
                                                <p style={{display:(parseInt(d.editpermission) == 1 ? 'block': 'none')}}>{d.description}</p> */}
                                                <h4 style={{display:(parseInt(d.editpermission) == 1 ? 'block': 'none')}}>{d.spacetype}</h4>
                                                <p style={{display:(parseInt(d.editpermission) == 1 ? 'none': 'none')}}>{d.description}</p>
                                                <h4 style={{display:(parseInt(d.editpermission) == 0 && d.spacetype.toLowerCase() == "copyright image." ? 'block': 'none')}}>{d.spacetype}</h4>
                                                <p style={{overflowY:'hidden',height:'20px',paddingTop:'unset',display:(parseInt(d.editpermission) == 0 && d.spacetype.toLowerCase() == "copyright image." ? 'block': 'none')}}>
                                                    <a href="javscript:;" data-filerefid={d.image} onClick={showcopyrightreference}>View Details</a>
                                                </p>
                                            </div>
                                            
                                            <div id="loaderdiv" style={{display:(d.processed == "0" ? 'block' :'none')}}>
                                                <MyLoader />
                                            </div>                                            
                                            <span className="removeuploaded showalways" data-filerefid={d.image} data-spacetype={d.spacetype} onClick={removefromprocessedlist} tooltip="Remove" flow="left">
                                                <FontAwesomeIcon icon={faRemove}/>
                                            </span>                                            
                                            <span className="removeuploaded" data-editpermission={d.editpermission} data-spacetype={d.spacetype} data-filerefid={d.image} onClick={ignorecompliance} style={{right:'45px'}} tooltip="Ignore Compliance" flow="left">
                                                <FontAwesomeIcon icon={faShieldHalved} style={{position:'relative',right:'3px',fontSize:'14px',color:'green'}}/>
                                            </span>
                                            <span className="removeuploaded" data-filerefid={d.image} onClick={editcompliance} style={{right:'75px',display:(parseInt(d.editpermission) == 1 ? 'block': 'none')}} tooltip="Edit Image" flow="left">
                                                <FontAwesomeIcon icon={faEdit} style={{position:'relative',right:'3px',fontSize:'14px',color:'green'}}/>
                                            </span>
                                            <span className="removeuploaded" data-filerefid={d.image} style={{right:'unset',left:'15px',width:'unset',height:'unset',borderRadius:'5px',paddingRight:'7px',color:'#9333ea',display:((d.condition) !== "NA"  ? 'inline-block': 'none')}} tooltip="Property Condition" flow="right">
                                                {d.condition}
                                            </span>
                                            <center className="invalidcompliance">
                                            <input type="file" name="img_logo" className="dropzonenew" title='' onChange={dropzonechangesingle} data-filreferenceidentity={d.image}
                                         accept="image/png, image/jpeg, image/jpg, image/heif, image/heic" style={{display:'none'}}></input>
                                                <a href="javascript:;" className="common-save" style={{margin:"15px"}} onClick={triggerfileupload}>Replace</a>
                                                </center>
                                        </li>
                                    )) : null
                                    }
                                </ul>
                                <div style={{display:((uploadedimages.length <= 0 && uploadedfile.length <= 0) ? 'block':'none')}}>
                                    <center>
                                        <a href="javascript:;" onClick={Addmoreimage} className="common-save">Add images</a>
                                        {/* <a href="javascript:;" onClick={resettoinitialwithajaxcheck} className="common-save">Start New</a> */}
                                    </center>
                                </div>
                            </div>

                            <div className="col-4 mlsrightphoto">
                                <h5>Photo breakdown:</h5>
                                {/* <h5>Interior</h5> */}
                                <div className="row">
                                    <div className="col-12">
                                        <ul className="photobreak">
                                            {/* {roomtypes.length > 0 ? roomtypes.map((d) => (
                                                <li>
                                                    <span>{d.name}</span>
                                                    <span>{d.count}</span>
                                                </li>
                                            )) : (uploadedimages.length > 0 ? 
                                            <li>
                                                <p className="loadingellipsis" style={{ fontSize: '14px' }}>Analyzing</p>
                                            </li>                                           
                                            : null )
                                            
                                            
                                            } */}
                                            {/* <li>
                                                <span>Kitchen</span>
                                                <span>5</span>
                                            </li>
                                            <li>
                                                <span>Living Room</span>
                                                <span>5</span>
                                            </li>
                                            <li>
                                                <span>Dining Area</span>
                                                <span>5</span>
                                            </li> */}
                                        </ul>
                                    </div>
                                    {/* <div className="col-6">
                                        <ul className="photobreak">
                                            <li>
                                                <span>Kitchen</span>
                                                <span>5</span>
                                            </li>
                                            <li>
                                                <span>Living Room</span>
                                                <span>5</span>
                                            </li>
                                            <li>
                                                <span>Dining Area</span>
                                                <span>5</span>
                                            </li>
                                        </ul>
                                    </div> */}
                                </div>
                                {/* <h5>Exterior</h5>
                                <div className="row">
                                    <div className="col-6">
                                        <ul className="photobreak">
                                            <li>
                                                <span>Kitchen</span>
                                                <span>5</span>
                                            </li>
                                            <li>
                                                <span>Living Room</span>
                                                <span>5</span>
                                            </li>
                                            <li>
                                                <span>Dining Area</span>
                                                <span>5</span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="col-6">
                                        <ul className="photobreak">
                                            <li>
                                                <span>Kitchen</span>
                                                <span>5</span>
                                            </li>
                                            <li>
                                                <span>Living Room</span>
                                                <span>5</span>
                                            </li>
                                            <li>
                                                <span>Dining Area</span>
                                                <span>5</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div> */}

                        <a href="javascript:;" id="complianceproceed" style={{display:'none',marginTop: "20px"}} className="common-save" onClick={showthirdstep}>Save Photos & Continue</a>
                        {/* {compliancepassed == true ?                         
                         <a href="javascript:;" id="complianceproceed" style={{display:'none'}} className="common-save" style={{ marginTop: "20px" }} onClick={showthirdstep}>Save Photos & Continue</a>                        
                         : null
                         } */}
                            </div>
                        </div>
                       
                        {/* <div className="row" style={{display:(compliancepassed == true ? 'flex': 'none')}}>
                            <div className="col-12" id="divpropertyaddress">
                                <div className="row">
                                    <div className="col-9" style={{position:"relative"}}>
                                        <label>
                                            Property address
                                        </label>
                                        <div className="search-location-input">
                                            <input id="txtPropAddress"
                                                ref={autoCompleteRef} className="common-input"
                                                onChange={event => setQuery(event.target.value)}
                                                placeholder="Enter your address"
                                                value={query}
                                            />
                                            <FontAwesomeIcon className="clearProp" onClick={()=> clearPropAddress()} icon={faXmark} />
                                            <input id="hfLocationId" value={locationId} type="hidden"></input>
                                        </div>
                                    </div>                                        
                                </div>
                            </div>
                        </div> */}
                        {/* {compliancepassed == true ? 
                        <>
                         <a href="javascript:;" className="common-save" style={{ marginTop: "20px" }} onClick={generatecontentfromdescription}>Save Photos & Continue</a>
                         </>
                         : null
                         } */}
                      
                    </div>
                    
                    <div className="col-10" id="divpropertydetails" style={{display:'none'}}>
                    
                        <div className="row">
                        <div className="col-12">
                                    <div className="row">
                                        <div className="col-12">
                                            <h4 className="prop-top-title">Property Details</h4>
                                        </div>
                                        <div className="col-12 mb-30">
                                            <div className="row">
                                                <div className="col-3">
                                                    <label className="prop-lab-title">1. Property type</label>
                                                    {/* <Propertytype /> */}
                                                    {/* <Dropdown id="ddlPropertyType" onChange={() => setPropertyType()} options={optionspropertyType} placeholder="Select" /> */}
                                                    <input type="hidden" id="hfPropertyType"></input>
                                                    <select id="ddlPropertyType">
                                                        <option value="select">Select</option>
                                                        <option value="singlefamily">Single-family</option>
                                                        <option value="multifamily">Multi-family</option>
                                                        <option value="condo">Condo</option>
                                                        <option value="townhouse">Townhouse</option>
                                                        <option value="villa">Villa</option>
                                                        <option value="apartment">Apartment</option>
                                                        <option value="residential">Residential</option>
                                                        <option value="land">Land</option>
                                                        <option value="commercial">Commercial</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 mb-30">
                                            <div className="row">
                                                <div className="col-3">
                                                    <label className="prop-lab-title">2. Property attributes</label>
                                                </div>
                                            </div>
                                            <div className="row" style={{alignItems:"flex-end"}}>
                                                <div className="col-2">
                                                    <label className="prop-lab-title1">Number of bedrooms<span style={{color:"red"}}><b>*</b></span></label>
                                                    {/* <Dropdown id="ddlBedrooms" options={optionsBedrroms} placeholder="Select" /> */}
                                                    <select id="ddlBedrooms">
                                                        <option value="select">Select</option>
                                                        <option value="1">1</option>
                                                        <option value="2">2</option>
                                                        <option value="3">3</option>
                                                        <option value="4">4</option>
                                                        <option value="5">5</option>
                                                        <option value="6">6</option>
                                                        <option value="7">7</option>
                                                        <option value="8">8</option>
                                                        <option value="9">9</option>
                                                        <option value="10">10</option>
                                                    </select>
                                                </div>
                                                <div className="col-2">
                                                    <label className="prop-lab-title1">Number of bathrooms<span style={{color:"red"}}><b>*</b></span></label>
                                                    {/* <Dropdown id="ddlBathrooms" options={optionsBathroms} placeholder="Select" /> */}
                                                    <select id="ddlBathrooms">
                                                        <option value="select">Select</option>
                                                        <option value="1">1</option>
                                                        <option value="1.5">1.5</option>
                                                        <option value="2">2</option>
                                                        <option value="2.5">2.5</option>
                                                        <option value="3">3</option>
                                                        <option value="3.5">3.5</option>
                                                        <option value="4">4</option>
                                                        <option value="4.5">4.5</option>
                                                        <option value="5">5</option>
                                                        <option value="5.5">5.5</option>
                                                        <option value="6">6</option>
                                                        <option value="6.5">6.5</option>
                                                        <option value="7">7</option>
                                                        <option value="7.5">7.5</option>
                                                        <option value="8">8</option>
                                                        <option value="8.5">8.5</option>
                                                        <option value="9">9</option>
                                                        <option value="9.5">9.5</option>
                                                        <option value="10">10</option>
                                                    </select>
                                                </div>
                                                <div className="col-2">
                                                    <label className="prop-lab-title1">Floors<span style={{color:"red"}}><b>*</b></span></label>
                                                    {/* <Dropdown id="ddlFloors" options={optionsFloors} placeholder="Select" /> */}
                                                     <select id="ddlFloors">
                                                        <option value="select">Select</option>
                                                        <option value="1">1</option>
                                                        <option value="2">2</option>
                                                        <option value="3">3</option>
                                                        <option value="4">4</option>
                                                        <option value="5">5</option>
                                                    </select>
                                                </div>
                                                <div className="col-2">
                                                    <label className="prop-lab-title1">Floor Area(sqft)<span style={{color:"red"}}><b>*</b></span></label>
                                                    <input id="txtArea" type="text" className="common-input" />
                                                </div>
                                                <div className="col-2">
                                                    <label className="prop-lab-title1">Garage type</label>
                                                    <select id="ddlGaragetype">
                                                    <option value="select">Select</option>
                                                        <option value="attached">attached</option>
                                                        <option value="detached">detached</option>
                                                    </select>
                                                </div>
                                                <div className="col-2">
                                                    <label className="prop-lab-title1">Garage spaces</label>
                                                    {/* <Dropdown id="ddlGaragespaces" options={optionsGarage} placeholder="No of cars" /> */}
                                                    <select id="ddlGaragespaces">
                                                        <option value="select">Select</option>
                                                        <option value="1">1 car</option>
                                                        <option value="2">2 cars</option>
                                                        <option value="3">3 cars</option>
                                                        <option value="4">4 cars</option>
                                                        <option value="5">5 cars</option>
                                                        <option value="6">6 cars</option>
                                                        <option value="7">7 cars</option>
                                                        <option value="8">8 cars</option>
                                                        <option value="9">9 cars</option>
                                                        <option value="10">10 cars</option>
                                                    </select>
                                                </div>                                                
                                            </div>
                                        </div>
                                        {/* <div className="col-12">
                                            <center><a href="javascript:;"  style={{margin:"15px 0 25px"}} className="common-save" onClick={generatecontentfromdescription}>Continue</a></center>
                                        </div> */}
                                    </div>
                                </div>
                        </div>

                        <div className="row" id="div1Result">                                        
                            <div className="col-12">
                                <div className="prop-title">Nearby amenities <span style={{ fontSize: "12px", lineHeight: "28px" }}>(found within the radius of 5 miles)</span></div>
                                <div style={{ fontSize: "12px" }}>Select the nearby amenities to be included in the property description.</div>
                            </div>
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-3">
                                        <div className="category-title">School/University</div>
                                        <div id="divSchoolsData">

                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="category-title">Healthcare</div>
                                        <div id="divHospitalsData">

                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="category-title">Parks</div>
                                        <div id="divParksData">

                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="category-title">Supermarket</div>
                                        <div id="divSsupermarketsData">

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-12">
                                        <center>
                                        <a href="javascript:;"  style={{margin:"15px 0 25px"}} className="common-save" onClick={generatecontentfromdescription}>Continue</a>
                                        <a href="javascript:;" className="common-clear" style={{margin:"15px 0 25px 15px"}} onClick={resetpropertydetails}>Clear</a>
                                        </center>
                                    </div>
                                </div>                            
                            </div>
                        </div>
                    </div>

                    <div className="col-10" id="editordiv" style={{display:'none'}}>
                        <div className="row">
                        <div className="col-12 text-end chech-right" style={{marginBottom:"10px"}}>
                                {/* <span><FontAwesomeIcon icon={faCopy} onClick={this.copyToClipboard} style={{marginLeft:'0px'}} /></span> */}
                                {copySacpeAvailable == true ? 
                                <span onClick={Checkplagiarism} tooltip="Check plagiarism" flow="left">
                                <FontAwesomeIcon icon={faShield} style={{fontSize:'24px',cursor:"pointer",color:'#9333ea'}} />
                                </span> : null }
                                <span
                                id="plagiarisminfo"
                                data-bs-toggle="modal"
                                data-bs-target="#exampleModal"
                                className="text-count"
                                style={{
                                    backgroundColor: "#f44336",
                                    color: "#fff",
                                    display: "none",
                                }}
                                >
                                5 copies found
                                </span>
                                {/* <span className="text-count">5 words</span> */}
                            </div>
                        </div>
                        <div className="row">                                                                                                
                                {/* {generatedcontent !=null && generatedcontent !="" ? generatedcontent.map((d) => (  */}
                                <div className="col-12">
                                        
                                    <div id="divOuterContent" className="output-wrap slider"> 
                                    <span className="float-end" id="spanCharCount" style={{fontSize:"13px",display:"block"}}>Character Count: <b id="lblCcount">125</b></span>                                                           
                                    {(grammarlyKeyData != "" ? 
                                    <GrammarlyEditorPlugin clientId={Cookies.get('g_key')}>
                                        <div id="divGeneratedContent" style={{minHeight:"55vh"}} className='out-content market-scroll'>
                                            
                                        </div>
                                    </GrammarlyEditorPlugin>     
                                    :
                                    <div id="divGeneratedContent" style={{minHeight:"55vh"}} className='out-content market-scroll'>
                                            
                                    </div>
                                    )}
                                        <div id="divOutputIcons" style={{display:"none", position: "relative",paddingBottom:"50px",zIndex:"39999"}} className="out-icons">
                                            <span className="float-end">
                                                <a href="javascript:;" onClick={()=>copyToClipboard()} className="common-border-btn">Copy</a>
                                                <a href="javascript:;" id="hrefEditContent" onClick={()=>copyToClipboardEdit()} className="common-border-btn">Edit</a>
                                                {/* <a href="javascript:;" id="hrefEditContent" onClick={()=>Highlightkeys('dropped or false ceiling, flooring parquet')} className="common-border-btn">replace</a> */}
                                                <a href="javascript:;" onClick={()=> generateaicontent()} className="common-border-btn">Rewrite</a>
                                            </span>
                                        </div>
                                    </div>
                                </div>                                                    
                                {/* )) : null }   */}
                        </div>
                    </div>
                    {/* <div className="col-10">
                        <div className="row">
                            <div className="col-6">
                                <h2 className="titlelist-desc">Listing Description</h2>
                            </div>
                            <div className="col-6">
                                <div className="wrap-list-desc">
                                    <img src="https://images.pexels.com/photos/3965521/pexels-photo-3965521.jpeg?auto=compress&cs=tinysrgb&w=1600"></img>
                                    <h4>123 Main St.</h4>
                                </div>
                            </div>
                            <div className="col-12" style={{marginTop:"50px"}}>
                                <div className="row">
                                    <div className="col-9">
                                        <div className="scrolldescpara">
                                            <p>Discover Single-Level Living in Whitefish River Ranch. Welcome to your dream home! </p><p>This single-level residence offers a perfect blend of elegance and comfort. With 4 bedrooms, 2 baths, and a generous 2,450 square feet of living space on one acre. </p><p>Bathed in natural light, the southern-facing windows grace the living room with an abundance of natural light, creating an inviting ambiance from dawn to dusk. And for those cozy evenings, a dual-sided fireplace effortlessly connects the living room to a chef's kitchen and dining room, providing a warm and welcoming setting for gatherings, entertaining, or simply unwinding in style.</p><p>The primary bedroom is a sanctuary in itself. With an ensuite bathroom featuring a soothing soaking tub, it's the perfect place to unwind, relax, and escape from the day's stresses. This is your personal oasis, right within your home. Step outside, and you'll be greeted by a meticulously manicured and landscaped large backyard. </p><p>It's a slice of paradise, fully fenced for privacy, with a garden that's ideal for green thumbs, and breathtaking unobstructed southern views that create a backdrop for unforgettable moments. It's the ultimate spot for backyard gatherings, BBQs, and the creation of cherished family memories.</p><p> Extraordinary Amenities: This home is not just about the indoors. An attached double car garage ensures convenience, while an additional detached 2-car garage/shop offers endless possibilities. Plus, there's an unfinished bonus room above the detached garage/shop, ready to be transformed into the space of your dreams. </p><p>Convenient Serenity: Whitefish River Ranch provides the best of both worlds. Conveniently located to access all the attractions and amenities that the Flathead Valley has to offer, Glacier National Park, Flathead Lake, Big Mountain Skiing, are less than an hour away, yet it remains a peaceful and quiet escape from the hustle and bustle. </p><p>Don't miss this opportunity to make this exceptional property your own. NEW ADDITIONAL PHOTOGRAPHS PLANNED for WEEK of October 30. For more information or to schedule a viewing, contact Steve Wray at 406-407-4744 or reach out to your real estate professional.</p>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <h4 className="descailisttitle">Choose an AI generated descripton</h4>
                                        <ul className="descailist">
                                            <li className="active">
                                                <FontAwesomeIcon icon={faStar} />
                                                <h4>Standard</h4>
                                            </li>
                                            <li>
                                                <FontAwesomeIcon icon={faList} />
                                                <h4>Descriptive</h4>
                                            </li>
                                            <li>
                                                <FontAwesomeIcon icon={faSmileBeam} />
                                                <h4>Playful</h4>
                                            </li>
                                            <li>
                                                <FontAwesomeIcon icon={faUserTie} />
                                                <h4>Professional</h4>
                                            </li>
                                            <li>
                                                <FontAwesomeIcon icon={faCheckSquare} />
                                                <h4>Simplified</h4>
                                            </li>
                                        </ul>
                                    </div>                                    
                                </div>
                            </div>
                        </div>
                    </div> */}



                    {/* {listingdescriptionstatus == 1 ?
                    <div className="col-10">
                        <div className="publishlist">
                            <img src={shieldicon} className="shieldicon"/>
                            <h2>All done!</h2>
                            <h4>Are you ready to publish?</h4>
                            <a href="javascript:;" className="common-save" style={{ marginTop: "20px" }} onClick={comingsoon}>Publish Listing</a>
                        </div>
                    </div>
                    : null} */}
                </div>
            </div>
      
            <div
          className="modal fade"
          id="exampleModal"
          tabIndex={-1}
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Plagiarism
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body" id="plagiarismmodalbody" dangerouslySetInnerHTML={plagiarismmodalbody}></div>
            </div>
          </div>
        </div>
 
        </div>

        <a href='javascript:;' id='hrefsubscription' data-bs-toggle="modal"
                          data-bs-target="#subscriptionnmodal" 
                          className="text-count"
                          style={{
                            backgroundColor: "#f44336",
                            color: "#fff",
                            display: "none",
                          }}></a>  
            <div className="modal fade declutterpopup" id="subscriptionnmodal" tabIndex={-1} aria-labelledby="subscriptionModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
      <div className="modal-dialog">
          <div className="modal-content eulamodalcss">
            <div id="overlaydeclutter">
                <div id="loading" style={{ top: "35%" }}>                                                        
                    <img src={loader} />
                    <h2 id="loaderheading"><span>Processing...</span></h2>
                </div>
            </div> 
            <div id="overlaydecluttermobile">
                <div id="loading" style={{ top: "35%" }}>                                                        
                    <img src={loader} />
                    <h2 id="loaderheading"><span>Processing...</span></h2>
                </div>
            </div> 
              <div className="modal-header">
                  <h5 className="modal-title" id="subscriptionModalLabel"><b>Edit</b></h5>    
                  <button id="modaldismissbutton" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={hidedeclutter}></button>              
              </div>
              <div className="modal-body" style={{maxHeight:"420px",overflowY:"auto",paddingBottom:"15px",position:'relative'}}>   
                    <div className='col-12' style={{marginBottom:"45px",position:'relative'}}>
                                        <div className='row'>
                                            <div className='col-12'>
                                                <center className='canvastyle' style={{width:(declutterimagewidth)+'px',height:(declutterimageheight)+'px',position:"relative",margin:'0 auto'}}>
                                                <div id="decluttersourcediv" style={{display:(showdeclutteruntouched == false ? 'block':'none')}}>
                                                    <img id="declutterimagesource" crossOrigin={"anonymous"} ></img>
                                                    {/* <CanvasDraw key={clearcanvas} canvasWidth={declutterimagewidth} canvasHeight={declutterimageheight} width={declutterimagewidth.toString()} height={declutterimageheight.toString()} hideGrid lazyRadius={1} brushRadius={brushradius} /> */}
                                                </div>
                                                <div id="decluttersourceuntoucheddiv" style={{display:(showdeclutteruntouched == true ? 'block':'none')}}>
                                                    <img id="decluttersourceimageuntouched" src={decluttersourceimageuntouched}></img>
                                                </div>
                                            </center>
                                            </div>
                                            <div className='col-12'>
                                                <center className='canvacontrol'>
                                                    <div id="editingdiv">                                                      
                                                        {/* <span style={{color:'#fff',marginRight:0,position:'relative',bottom:'4px'}}>Brush:</span>
                                                        <span style={{minWidth:"130px"}}>                                                        
                                                            <InputRange
                                                            maxValue={30}
                                                            minValue={15}
                                                            value={brushradius}
                                                            onChange={value => setRadius(value)}
                                                            />
                                                        </span> */}
                                                        {/* <span>
                                                            <a id="resetdeclutterbutton" href='javascript:;' className='canvaclearbtn' onClick={cleanCanvas} tooltip="Click to remove the eraser strokes." flow="up">Undo</a>
                                                        </span> */}
                                                        <span className='mobilemargintop'>
                                                            <a href='javascript:;' className='canvausebtn' onClick={savecanvas} tooltip="Remove the non compliance objects from the image in one click." flow="up">Remove Objects</a>
                                                        </span>
                                                        <span>
                                                            <a href='javascript:;' className='canvausebtn' onClick={usedeclutteredimage} tooltip="Replace this image with the original image." flow="up">Select</a>
                                                        </span>
                                                    </div>
                                                </center>
                                            </div>                                            
                                        </div>
                                    </div>
              </div>
          </div>
      </div>
      </div>


      <a href='javascript:;' id='hrefcopyrightmodal' data-bs-toggle="modal"
                          data-bs-target="#copyrightmodal" 
                          className="text-count"
                          style={{
                            backgroundColor: "#f44336",
                            color: "#fff",
                            display: "none",
                          }}></a>  
      <div
          className="modal fade"
          id="copyrightmodal"
          tabIndex={-1}
          aria-labelledby="copyrightmodalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" style={{maxWidth:'900px'}}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="copyrightmodalLabel">
                Image Attribution Details
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body" id="copyrightmodalbody">
                <div className="row">
                    <div className='col-12 matchfoundcss' id="divResult">                    
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </>
    )
    // }
};



export default Mls;